/**
 * DEVELOPER DOCUMENTATION (Focal theme) — see theme docs for events:
 * variant:changed, variant:added, cart:updated, cart:refresh; custom elements
 * (drawer, popover, quick-buy-drawer...) expose an "open" property.
 */

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: Globo (Smart Product Filter) collection grid quick view + quiet add-to-cart
 *
 * 1. Moves Globo's .open-quick-view link into the hover Add-to-cart form row.
 * 2. Hijacks quick-view clicks to the theme's lightweight quick-buy drawer.
 * 3. Hijacks Globo's Add-to-cart form (a plain POST to /cart/add that would
 *    navigate to the cart page): adds via AJAX instead, fires the theme's
 *    green "added to cart" notification, team-colored confetti and a
 *    mini-cart refresh — the shopper stays on the page.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  function placeGloboQuickViews() {
    document.querySelectorAll('.spf-product-card').forEach(function (card) {
      var quickView = card.querySelector('.open-quick-view');
      var form = card.querySelector('.spf-product__form');

      if (quickView && form && quickView.parentElement !== form) {
        form.appendChild(quickView);
      }
    });
  }

  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      placeGloboQuickViews();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  function getCardProductPath(card) {
    var link = card.querySelector('a.spf-product-card__image-wrapper[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    try {
      return new URL(link.getAttribute('href'), window.location.origin).pathname;
    } catch (error) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var quickView = event.target.closest ? event.target.closest('.spf-product-card .open-quick-view, .spf-product__form .open-quick-view') : null;
    if (!quickView) return;

    var card = quickView.closest('.spf-product-card');
    if (!card) return;

    var productPath = getCardProductPath(card);
    if (!productPath || !window.customElements || !window.customElements.get('quick-buy-drawer')) {
      return; // fall back to Globo's own quick view
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var previous = document.getElementById('zubaz-globo-quick-buy');
    if (previous) previous.remove();

    var drawer = document.createElement('quick-buy-drawer');
    drawer.id = 'zubaz-globo-quick-buy';
    drawer.setAttribute('href', productPath);
    drawer.className = 'drawer drawer--large drawer--quick-buy';
    document.body.appendChild(drawer);

    requestAnimationFrame(function () {
      drawer.open = true;
    });
  }, true);

  /* quiet add-to-cart for Globo grid forms */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches) return;
    if (!form.matches('form.spf-product__form') && !form.matches('.spf-product-card form[action*="/cart/add"]')) return;

    event.preventDefault();

    var btn = form.querySelector('button[type="submit"], button.spf-product__form-btn-addtocart');
    var originalText = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function (item) {
        var card = form.closest('.spf-product-card');
        var titleLink = card ? card.querySelector('a[href*="/products/"]') : null;
        var title = (item && item.product_title) || (titleLink ? titleLink.textContent : '');

        document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', { bubbles: true, cancelable: true, detail: { status: 'success' } }));
        window.zubazConfetti && window.zubazConfetti(window.zubazTeamColorsFromText ? window.zubazTeamColorsFromText(title) : null);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (btn) {
          btn.textContent = 'ADDED ✓';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1600);
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.submit(); // sold out or network issue — fall back to the regular flow
      });
  }, true);
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: shared team data + helpers
 * ------------------------------------------------------------------------------------------------------------ */
window.ZUBAZ_TEAMS = {
  'arizona-cardinals':     { name: 'Arizona Cardinals',     primary: '#97233F', secondary: '#FFB612', slogan: 'Rise Up Red Sea', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Cardinals_Hood.png?v=1721329492' },
  'atlanta-falcons':       { name: 'Atlanta Falcons',       primary: '#A71930', secondary: '#000000', slogan: 'Rise Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Falcons_Hood.png?v=1721331642' },
  'baltimore-ravens':      { name: 'Baltimore Ravens',      primary: '#241773', secondary: '#9E7C0C', slogan: 'Ravens Flock', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_ravens_hood_copy.png?v=1721331481' },
  'buffalo-bills':         { name: 'Buffalo Bills',         primary: '#00338D', secondary: '#C60C30', slogan: 'Bills Mafia', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Bills_Hood.png?v=1721330360' },
  'carolina-panthers':     { name: 'Carolina Panthers',     primary: '#0085CA', secondary: '#101820', slogan: 'Keep Pounding', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_panthers_hood_copy.png?v=1721332172' },
  'chicago-bears':         { name: 'Chicago Bears',         primary: '#0B162A', secondary: '#C83803', slogan: 'Da Bears', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Bears_Hood.png?v=1721330215' },
  'cincinnati-bengals':    { name: 'Cincinnati Bengals',    primary: '#FB4F14', secondary: '#000000', slogan: 'Who Dey', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Bengals_Hood.png?v=1721331338' },
  'cleveland-browns':      { name: 'Cleveland Browns',      primary: '#311D00', secondary: '#FF3C00', slogan: 'Dawg Pound', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Browns_Hood.png?v=1721331065' },
  'dallas-cowboys':        { name: 'Dallas Cowboys',        primary: '#003594', secondary: '#869397', slogan: 'How ’Bout Them Cowboys', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_dallas_copy.png?v=1721332891' },
  'denver-broncos':        { name: 'Denver Broncos',        primary: '#FB4F14', secondary: '#002244', slogan: 'Broncos Country', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Broncos_Hood.png?v=1721330344' },
  'detroit-lions':         { name: 'Detroit Lions',         primary: '#0076B6', secondary: '#B0B7BC', slogan: 'One Pride', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Lions_Hood.png?v=1721331425' },
  'green-bay-packers':     { name: 'Green Bay Packers',     primary: '#203731', secondary: '#FFB612', slogan: 'Go Pack Go', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Packers_Hood.png?v=1721331547' },
  'houston-texans':        { name: 'Houston Texans',        primary: '#03202F', secondary: '#A71930', slogan: 'Bulls On Parade', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_texans_hood_copy.png?v=1721331325' },
  'indianapolis-colts':    { name: 'Indianapolis Colts',    primary: '#002C5F', secondary: '#A2AAAD', slogan: 'For The Shoe', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Colts_Hood.png?v=1721331622' },
  'jacksonville-jaguars':  { name: 'Jacksonville Jaguars',  primary: '#006778', secondary: '#D7A22A', slogan: 'DUUUVAL', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Jaguars_Hood.png?v=1721331580' },
  'kansas-city-chiefs':    { name: 'Kansas City Chiefs',    primary: '#E31837', secondary: '#FFB81C', slogan: 'Chiefs Kingdom', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Chiefs_Hood.png?v=1721330373' },
  'las-vegas-raiders':     { name: 'Las Vegas Raiders',     primary: '#000000', secondary: '#A5ACAF', slogan: 'Raider Nation', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_raiders_hood_copy.png?v=1721331296' },
  'los-angeles-chargers':  { name: 'Los Angeles Chargers',  primary: '#0080C6', secondary: '#FFC20E', slogan: 'Bolt Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Chargers_Hood.png?v=1721331633' },
  'los-angeles-rams':      { name: 'Los Angeles Rams',      primary: '#003594', secondary: '#FFA300', slogan: 'Rams House', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_rams_hood_copy.png?v=1721331278' },
  'miami-dolphins':        { name: 'Miami Dolphins',        primary: '#008E97', secondary: '#FC4C02', slogan: 'Fins Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Dolphins_Hood.png?v=1721331352' },
  'minnesota-vikings':     { name: 'Minnesota Vikings',     primary: '#4F2683', secondary: '#FFC62F', slogan: 'Skol Vikings', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_vikings_hood_copy.png?v=1721331191' },
  'new-england-patriots':  { name: 'New England Patriots',  primary: '#002244', secondary: '#C60C30', slogan: 'Go Pats', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_titans_hood_copy.png?v=1721331531' },
  'new-orleans-saints':    { name: 'New Orleans Saints',    primary: '#101820', secondary: '#D3BC8D', slogan: 'Who Dat', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_saints_hood_copy.png?v=1721331365' },
  'new-york-giants':       { name: 'New York Giants',       primary: '#0B2265', secondary: '#A71930', slogan: 'Big Blue', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Giants_Hood.png?v=1721331503' },
  'new-york-jets':         { name: 'New York Jets',         primary: '#125740', secondary: '#FFFFFF', slogan: 'J-E-T-S', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Jets_Hood.png?v=1721331203' },
  'philadelphia-eagles':   { name: 'Philadelphia Eagles',   primary: '#004C54', secondary: '#A5ACAF', slogan: 'Fly Eagles Fly', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Eagles_Hood.png?v=1721331309' },
  'pittsburgh-steelers':   { name: 'Pittsburgh Steelers',   primary: '#101820', secondary: '#FFB612', slogan: 'Here We Go', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_steelers_hood_copy.png?v=1721331043' },
  'san-francisco-49ers':   { name: 'San Francisco 49ers',   primary: '#AA0000', secondary: '#B3995D', slogan: 'Go Niners', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Forty9ers_Hood.png?v=1721331438' },
  'seattle-seahawks':      { name: 'Seattle Seahawks',      primary: '#002244', secondary: '#69BE28', slogan: 'Go Hawks', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_seahawks_hood_copy.png?v=1721331469' },
  'tampa-bay-buccaneers':  { name: 'Tampa Bay Buccaneers',  primary: '#D50A0A', secondary: '#FF7900', slogan: 'Fire The Cannons', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Buccaneers_Hood.png?v=1721331410' },
  'tennessee-titans':      { name: 'Tennessee Titans',      primary: '#0C2340', secondary: '#4B92DB', slogan: 'Titan Up', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/wa_agi-50721-s_sh11_titans_hood_copy_5c5d6c6b-e668-4139-b07a-ad8b70e7cdd3.png?v=1721332234' },
  'washington-commanders': { name: 'Washington Commanders', primary: '#5A1414', secondary: '#FFB612', slogan: 'Hail!', icon: 'https://cdn.shopify.com/s/files/1/0549/7284/2064/collections/WA_AGI-50721-S_SH11_Washington_Hood_copy.png?v=1732038188' }
};

window.zubazTeamTextColor = function (hex) {
  var c = String(hex || '').replace('#', '');
  if (c.length !== 6) return '#ffffff';
  var r = parseInt(c.substr(0, 2), 16);
  var g = parseInt(c.substr(2, 2), 16);
  var b = parseInt(c.substr(4, 2), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) > 150 ? '#000000' : '#ffffff';
};

/* Match a product title (or any text) to a team and return confetti colors. */
window.zubazTeamColorsFromText = function (text) {
  if (!text) return null;
  var lower = String(text).toLowerCase();
  var handles = Object.keys(window.ZUBAZ_TEAMS);

  for (var i = 0; i < handles.length; i++) {
    var team = window.ZUBAZ_TEAMS[handles[i]];
    if (lower.indexOf(team.name.toLowerCase()) !== -1) {
      return [team.primary, team.secondary, '#ffffff'];
    }
  }

  return null;
};

window.zubazGetTeam = function () {
  try {
    var h = localStorage.getItem('zubaz-team');
    return (h && window.ZUBAZ_TEAMS[h]) ? h : null;
  } catch (error) {
    return null;
  }
};

/* Feature-usage telemetry: thin GA4 wrapper (silent no-op when gtag is absent
   or consent-blocked). Event names are prefixed zbz_ to group in GA4. */
window.zbzGa = function (name, params) {
  try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (error) { /* never break the page */ }
};

window.zubazSetTeam = function (handle) {
  try { localStorage.setItem('zubaz-team', handle); } catch (error) { /* private mode */ }
  window.zbzGa('zbz_team_pick', { team: handle });
  document.dispatchEvent(new CustomEvent('zubaz:team', { detail: { handle: handle } }));
};

window.zubazClearTeam = function () {
  try { localStorage.removeItem('zubaz-team'); } catch (error) { /* private mode */ }
  document.dispatchEvent(new CustomEvent('zubaz:team', { detail: { handle: null } }));
};

/* Shared: fetch every product in a collection (products.json caps at 250/page;
   big team collections exceed that, and accessories sort low). Max 4 pages. */
window.zubazFetchCollection = function (handle) {
  var all = [];
  function page(n) {
    return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var items = data.products || [];
        all = all.concat(items);
        if (items.length === 250 && n < 4) return page(n + 1);
        return all;
      });
  }
  return page(1);
};

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: add-to-cart celebration (confetti)
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var lastBurst = 0;

  window.zubazConfetti = function (colors) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var now = Date.now();
    if (now - lastBurst < 1500) return;
    lastBurst = now;

    var palette = (colors && colors.length) ? colors : ['#ff37b8', '#f3ff34', '#ffffff', '#000000'];

    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:100001;';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var parts = [];

    for (var i = 0; i < 80; i++) {
      parts.push({
        x: canvas.width / 2 + (Math.random() - 0.5) * 120,
        y: canvas.height * 0.35,
        vx: (Math.random() - 0.5) * 16,
        vy: -(5 + Math.random() * 11),
        w: 5 + Math.random() * 6,
        h: 3 + Math.random() * 4,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: palette[i % palette.length]
      });
    }

    var frame = 0;

    function tick() {
      frame++;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      parts.forEach(function (p) {
        p.vy += 0.38;
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.99;
        p.rot += p.vr;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, 1 - frame / 80);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });

      if (frame < 80) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
      }
    }

    requestAnimationFrame(tick);
  };

  document.addEventListener('variant:added', function (event) {
    var variant = event.detail && event.detail.variant;
    var title = variant ? (variant.product_title || variant.name || variant.title || '') : '';
    window.zubazConfetti(window.zubazTeamColorsFromText(title));
  });

  document.addEventListener('zubaz:confetti', function (event) {
    var detail = event.detail || {};
    var colors = detail.colors || null;

    if (!colors && detail.teamHandle && window.ZUBAZ_TEAMS[detail.teamHandle]) {
      var team = window.ZUBAZ_TEAMS[detail.teamHandle];
      colors = [team.primary, team.secondary, '#ffffff'];
    }

    window.zubazConfetti(colors);
  });
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: team picker
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var pills = [];
  var modal = null;

  function nickname(name) {
    var parts = name.split(' ');
    return parts[parts.length - 1];
  }

  function updatePills() {
    var handle = window.zubazGetTeam();

    pills.forEach(function (pill) {
      // "×" chip next to the pill: turns team mode off and goes back to
      // showing everything (Eli 2026-07-28). Only rendered while picked.
      var clear = pill._zbzClear;
      if (handle && !clear) {
        clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'zubaz-team-clear';
        clear.setAttribute('aria-label', 'Turn off team mode — show everything');
        clear.setAttribute('title', 'Show everything');
        clear.textContent = '×';
        clear.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          window.zbzGa('zbz_team_clear', {});
          window.zubazClearTeam();
          window.location.reload();
        });
        pill.parentNode.insertBefore(clear, pill.nextSibling);
        pill._zbzClear = clear;
      }
      if (clear) clear.style.display = handle ? '' : 'none';

      // phones get a compact football-only pill — the full label doesn't fit
      // next to the logo (Eli 2026-07-28)
      var compact = window.matchMedia('(max-width: 999px)').matches;
      if (handle) {
        var team = window.ZUBAZ_TEAMS[handle];
        pill.textContent = compact ? '🏈' : '🏈 ' + (team.slogan || 'GO ' + nickname(team.name).toUpperCase() + '!');
        pill.setAttribute('aria-label', 'Your team: ' + team.name);
        pill.style.background = team.primary;
        pill.style.color = window.zubazTeamTextColor(team.primary);
        pill.style.borderColor = team.secondary;
      } else {
        pill.textContent = compact ? '🏈' : '🏈 PICK YOUR TEAM';
        pill.setAttribute('aria-label', 'Pick your team');
        pill.style.background = '';
        pill.style.color = '';
        pill.style.borderColor = '';
      }
    });
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'zubaz-team-modal';
    modal.innerHTML =
      '<div class="zubaz-team-modal__overlay" data-action="close"></div>' +
      '<div class="zubaz-team-modal__panel" role="dialog" aria-label="Pick your team">' +
      '<button type="button" class="zubaz-team-modal__close" data-action="close" aria-label="Close">×</button>' +
      '<p class="zubaz-team-modal__title">Who’s your team?</p>' +
      '<p class="zubaz-team-modal__sub">We’ll remember it and point you straight at your gear.</p>' +
      '<a class="zubaz-team-modal__shop" hidden></a>' +
      '<div class="zubaz-team-modal__grid"></div>' +
      '<button type="button" class="zubaz-team-modal__none">No team — just show me everything</button>' +
      '</div>';

    var grid = modal.querySelector('.zubaz-team-modal__grid');

    Object.keys(window.ZUBAZ_TEAMS).forEach(function (handle) {
      var team = window.ZUBAZ_TEAMS[handle];
      var btn = document.createElement('button');
      btn.type = 'button';

      if (team.icon) {
        btn.className = 'zubaz-team-modal__team zubaz-team-modal__team--icon';
        btn.title = team.name;
        btn.setAttribute('aria-label', team.name);
        btn.innerHTML = '<img loading="lazy" alt="" src="' + team.icon + '&width=200">';
      } else {
        btn.className = 'zubaz-team-modal__team';
        btn.textContent = team.name;
        btn.style.background = team.primary;
        btn.style.color = window.zubazTeamTextColor(team.primary);
        btn.style.borderBottom = '4px solid ' + team.secondary;
      }

      btn.addEventListener('click', function () {
        window.zubazSetTeam(handle);
        updatePills();
        close();
        window.zubazConfetti && window.zubazConfetti([team.primary, team.secondary, '#ffffff']);
      });
      grid.appendChild(btn);
    });

    modal.querySelector('.zubaz-team-modal__none').addEventListener('click', function () {
      window.zubazClearTeam();
      updatePills();
      close();
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-action="close"]')) close();
    });

    document.body.appendChild(modal);
  }

  function open() {
    if (!modal) buildModal();

    var shop = modal.querySelector('.zubaz-team-modal__shop');
    var handle = window.zubazGetTeam();

    if (handle) {
      var team = window.ZUBAZ_TEAMS[handle];
      shop.hidden = false;
      shop.href = '/collections/' + handle;
      shop.textContent = 'Shop ' + team.name + ' gear →';
    } else {
      shop.hidden = true;
    }

    modal.classList.add('is-open');
    // Codex fix #7: floating widgets (Zendesk launcher, '90s toggle) overlap
    // the picker's lower rows on mobile — CSS hides them via this class.
    document.documentElement.classList.add('zbz-picker-open');
  }

  function close() {
    if (modal) modal.classList.remove('is-open');
    document.documentElement.classList.remove('zbz-picker-open');
  }

  function init() {
    if (!window.ZUBAZ_TEAMS) return;

    var hosts = document.querySelectorAll('.header__icon-list');
    if (!hosts.length) {
      var fallback = document.querySelector('.header__wrapper');
      hosts = fallback ? [fallback] : [];
    }

    hosts.forEach(function (host) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'zubaz-team-pill';
      pill.addEventListener('click', open);
      host.appendChild(pill);
      pills.push(pill);
    });

    updatePills();
    document.addEventListener('zubaz:team', updatePills);
    document.addEventListener('zubaz:open-picker', open);
    window.matchMedia('(max-width: 999px)').addEventListener('change', updatePills);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: homepage team personalization
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (window.location.pathname !== '/') return;

  var qvStyle = document.createElement('style');
  qvStyle.textContent =
    '.zubaz-pers-card { position: relative; }' +
    '.zubaz-pers-card__qv { display: block; margin: -16px auto 0; position: relative; background: #ff37b8; color: #ffffff; border: 0; border-radius: 30px; padding: 7px 16px; font-size: 11px; font-weight: 800; letter-spacing: 0.06em; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.25); }' +
    '.zubaz-pers-card__qv:hover { background: #282828; }';
  document.head.appendChild(qvStyle);

  function openQuickBuy(path) {
    if (!path) return;
    if (!window.customElements || !window.customElements.get('quick-buy-drawer')) {
      window.location.href = path;
      return;
    }
    var previous = document.getElementById('zubaz-pers-quick-buy');
    if (previous) previous.remove();
    var drawer = document.createElement('quick-buy-drawer');
    drawer.id = 'zubaz-pers-quick-buy';
    drawer.setAttribute('href', path);
    drawer.className = 'drawer drawer--large drawer--quick-buy';
    document.body.appendChild(drawer);
    requestAnimationFrame(function () { drawer.open = true; });
  }

  function money(value) {
    var n = parseFloat(value);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  }

  function findSection(key, title) {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section--featured-collections'));
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getAttribute('data-zbz-pers') === key) return sections[i];
      var h = sections[i].querySelector('h2, .heading');
      if (h && h.textContent.trim() === title) return sections[i];
    }
    return null;
  }

  function buildGrid(products) {
    var grid = document.createElement('div');
    grid.className = 'zubaz-pers-grid';

    products.forEach(function (p) {
      var variant = (p.variants || []).filter(function (v) { return v.available !== false; })[0];
      var img = p.images[0].src;
      img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=420';

      var card = document.createElement('a');
      card.className = 'zubaz-pers-card';
      card.href = '/products/' + p.handle;
      card.innerHTML =
        '<img class="zubaz-pers-card__img" loading="lazy" alt="" src="' + img + '">' +
        '<button type="button" class="zubaz-pers-card__qv" data-path="/products/' + p.handle + '">QUICK VIEW</button>' +
        '<div class="zubaz-pers-card__name">' + p.title + '</div>' +
        '<div class="zubaz-pers-card__price">' + money(variant ? variant.price : '') + '</div>';
      grid.appendChild(card);
    });

    grid.addEventListener('click', function (event) {
      var qv = event.target.closest('.zubaz-pers-card__qv');
      if (!qv) return;
      event.preventDefault();
      event.stopPropagation();
      openQuickBuy(qv.getAttribute('data-path'));
    });

    return grid;
  }

  function personalizeSection(key, title, products, headingText, ctaText, ctaHref, note) {
    var sec = findSection(key, title);
    if (!sec || !products.length) return;
    sec.setAttribute('data-zbz-pers', key);

    Array.prototype.forEach.call(sec.querySelectorAll('product-list, .tabs-nav'), function (el) { el.style.display = 'none'; });
    Array.prototype.forEach.call(sec.querySelectorAll('a.button:not(.zubaz-pers-cta)'), function (el) { el.style.display = 'none'; });

    var heading = sec.querySelector('h2, .heading');
    if (heading && headingText) heading.textContent = headingText;

    var host = sec.querySelector('.featured-collections') || sec;

    var oldGrid = sec.querySelector('.zubaz-pers-grid');
    if (oldGrid) oldGrid.remove();
    var oldWrap = sec.querySelector('.zbz-na-wrap');
    if (oldWrap) oldWrap.remove();
    var oldFoot = sec.querySelector('.zubaz-pers-foot');
    if (oldFoot) oldFoot.remove();

    // Mockup format (Eli 2026-07-28): 4 visible, left/right arrows page
    // through the rest, SHOP ALL as a link in the header top-right.
    var wrap = document.createElement('div');
    wrap.className = 'zbz-na-wrap';
    var grid = buildGrid(products);
    wrap.appendChild(grid);
    wrap.insertAdjacentHTML('beforeend',
      '<button type="button" class="zbz-na-arr zbz-na-arr--prev" aria-label="Previous"><svg viewBox="0 0 10 18" width="11" height="19" aria-hidden="true"><path d="M9 1L1 9l8 8" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<button type="button" class="zbz-na-arr zbz-na-arr--next" aria-label="Next"><svg viewBox="0 0 10 18" width="11" height="19" aria-hidden="true"><path d="M1 1l8 8-8 8" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>');
    host.appendChild(wrap);
    var prev = wrap.querySelector('.zbz-na-arr--prev');
    var next = wrap.querySelector('.zbz-na-arr--next');
    function syncArrows() {
      prev.disabled = grid.scrollLeft < 10;
      next.disabled = grid.scrollLeft > grid.scrollWidth - grid.clientWidth - 10;
    }
    prev.addEventListener('click', function () { grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' }); });
    grid.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();

    var hdrEl = sec.querySelector('.section__header');
    if (hdrEl) {
      var sa = hdrEl.querySelector('.zbz-na-shopall');
      if (!sa) {
        sa = document.createElement('a');
        sa.className = 'zbz-na-shopall';
        hdrEl.appendChild(sa);
      }
      sa.href = ctaHref;
      sa.textContent = 'SHOP ALL';
    }

    var foot = document.createElement('div');
    foot.className = 'zubaz-pers-foot';
    foot.innerHTML = (note ? '<p class="zubaz-pers-note">' + note + '</p>' : '');
    host.appendChild(foot);

    var changeLink = foot.querySelector('[data-zbz-change]');
    if (changeLink) {
      changeLink.addEventListener('click', function (event) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('zubaz:open-picker'));
      });
    }
  }
  // Shared with the New-Arrivals variety pass (Codex fix #5)
  window.zbzPersonalizeSection = personalizeSection;

  function personalize() {
    var handle = window.zubazGetTeam && window.zubazGetTeam();
    var team = handle && window.ZUBAZ_TEAMS[handle];

    if (!team) {
      if (document.querySelector('[data-zbz-pers]')) window.location.reload();
      return;
    }

    window.zubazFetchCollection(handle)
      .then(function (products) {
        var valid = (products || []).filter(function (p) {
          if (/gift card/i.test(p.title)) return false;
          if (!p.images || !p.images.length) return false;
          return (p.variants || []).some(function (v) { return v.available !== false; });
        });

        var newest = valid.slice().sort(function (a, b) {
          return new Date(b.published_at) - new Date(a.published_at);
        }).slice(0, 8);

        var newestIds = {};
        newest.forEach(function (p) { newestIds[p.id] = true; });

        var picks = valid.filter(function (p) { return !newestIds[p.id]; }).slice(0, 8);

        personalizeSection(
          'na', 'New Arrivals', newest,
          team.name + ' New Arrivals',
          'SHOP ALL ' + team.name.toUpperCase() + ' NEW ARRIVALS',
          '/collections/' + handle + '?sort_by=created-descending',
          null
        );

        personalizeSection(
          'sbt', 'Shop by team', picks,
          'Your Team: ' + team.name,
          'SHOP ALL ' + team.name.toUpperCase() + ' GEAR',
          '/collections/' + handle,
          'Not your team? <a href="#" data-zbz-change>Change it</a>'
        );
      })
      .catch(function () { /* leave the stock sections */ });
  }

  function boot() {
    if (!window.ZUBAZ_TEAMS) { setTimeout(boot, 200); return; }
    personalize();
    document.addEventListener('zubaz:team', personalize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: team-color collection pages
 * NOTE: Focal renders the page body in <div id="main"> — there is no <main>.
 * The fit builder's ADD button is excluded — it stays Zubaz pink.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var match = window.location.pathname.match(/^\/collections\/([a-z0-9-]+)/);
  if (!match) return;

  var team = window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[match[1]];
  if (!team) return;

  var style = document.createElement('style');
  style.textContent =
    '#main h1, main h1 { color: ' + team.primary + '; display: inline-block; border-bottom: 5px solid ' + team.secondary + '; padding-bottom: 8px; }' +
    '.zubaz-team-stripe { height: 10px; background: linear-gradient(90deg, ' + team.primary + ' 0 60%, ' + team.secondary + '); }' +
    '#main .button--primary:not(.zubaz-fb__addall), main .button--primary:not(.zubaz-fb__addall) { background: ' + team.primary + ' !important; color: ' + window.zubazTeamTextColor(team.primary) + ' !important; }';
  document.head.appendChild(style);

  function addStripe() {
    var main = document.querySelector('main, #main');
    if (main && !main.querySelector('.zubaz-team-stripe')) {
      var stripe = document.createElement('div');
      stripe.className = 'zubaz-team-stripe';
      main.prepend(stripe);
    }
    // unified team header band: guide-banner line + the server-rendered
    // category chips (from zbz-bigfilter.liquid) share one styled container
    // right under the team stripe. Styling lives in zbz-launch.css.
    if (main && !main.querySelector('.zubaz-team-band')) {
      var band = document.createElement('div');
      band.className = 'zubaz-team-band';
      var bar = document.createElement('div');
      bar.className = 'zubaz-guide-link';
      bar.style.cssText = 'text-align:center;font-size:14px;font-weight:600;';
      bar.innerHTML = '&#127944; Going to a game? <a href="/pages/what-to-wear-' + match[1] + '-game" style="text-decoration:underline;color:' + team.primary + ';">What to wear to a ' + team.name + ' game &rarr;</a>';
      bar.querySelector('a').addEventListener('click', function () { window.zbzGa && window.zbzGa('zbz_guide_banner_click', { team: match[1] }); });
      band.appendChild(bar);
      var chips = document.querySelector('.zbz-bf-teamcats');
      if (chips) band.appendChild(chips);
      var stripeEl = main.querySelector('.zubaz-team-stripe');
      if (stripeEl && stripeEl.nextSibling) { main.insertBefore(band, stripeEl.nextSibling); } else { main.prepend(band); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStripe);
  } else {
    addStripe();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: compact sticky header — shrink the logo once scrolled past the
 * fold (CSS lives in zbz-launch.css under html.zbz-compact-header).
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var on = false;
  function upd() {
    var want = window.scrollY > 120;
    if (want !== on) { on = want; document.documentElement.classList.toggle('zbz-compact-header', on); }
  }
  window.addEventListener('scroll', upd, { passive: true });
  upd();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: gameday-guide banner on NCAA team collection pages
 * (NFL teams get theirs from the team-color IIFE above; NCAA schools aren't in
 * ZUBAZ_TEAMS, so this small map covers them with neutral Zubaz-pink styling.)
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var NCAA = {
    'auburn-tigers': 'Auburn Tigers', 'duke-blue-devils': 'Duke Blue Devils',
    'georgia-tech-yellow-jackets': 'Georgia Tech Yellow Jackets', 'iowa-hawkeyes': 'Iowa Hawkeyes',
    'kansas-jayhawks': 'Kansas Jayhawks', 'lsu-tigers': 'LSU Tigers',
    'missouri-tigers': 'Missouri Tigers', 'oregon-ducks': 'Oregon Ducks', 'oregon-state-beavers': 'Oregon State Beavers',
    'purdue-boilermakers': 'Purdue Boilermakers', 'syracuse-orange': 'Syracuse Orange',
    'tcu-horned-frogs': 'TCU Horned Frogs', 'west-virginia-mountaineers': 'West Virginia Mountaineers'
  };
  var m = window.location.pathname.match(/^\/collections\/([a-z0-9-]+)/);
  if (!m || !NCAA[m[1]]) return;
  function add() {
    var main = document.querySelector('main, #main');
    if (!main || main.querySelector('.zubaz-team-band')) return;
    var band = document.createElement('div');
    band.className = 'zubaz-team-band';
    var bar = document.createElement('div');
    bar.className = 'zubaz-guide-link';
    bar.style.cssText = 'text-align:center;font-size:14px;font-weight:600;';
    var art = /^(A|E|I|O|U|LSU)/.test(NCAA[m[1]]) ? 'an' : 'a';
    bar.innerHTML = '&#127944; Going to a game? <a href="/pages/what-to-wear-' + m[1] + '-game" style="text-decoration:underline;color:#ff37b8;">What to wear to ' + art + ' ' + NCAA[m[1]] + ' game &rarr;</a>';
    bar.querySelector('a').addEventListener('click', function () { window.zbzGa && window.zbzGa('zbz_guide_banner_click', { team: m[1] }); });
    band.appendChild(bar);
    var chips = document.querySelector('.zbz-bf-teamcats');
    if (chips) band.appendChild(chips);
    main.prepend(band);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: shareable team links (?team=<handle>)
 * Ads, social posts and QR codes can deep-link fans into the personalized
 * site: zubaz.com/?team=buffalo-bills auto-picks that team (colors, countdown,
 * cart copy all follow). No-op for unknown handles or when already picked.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var t;
  try { t = (new URLSearchParams(location.search).get('team') || '').toLowerCase(); } catch (e) { return; }
  if (!t) return;
  var tries = 0;
  (function apply() {
    if (!window.ZUBAZ_TEAMS || !window.zubazSetTeam) { if (++tries < 25) setTimeout(apply, 200); return; }
    if (!window.ZUBAZ_TEAMS[t]) return;
    if (window.zubazGetTeam && window.zubazGetTeam() === t) return;
    window.zubazSetTeam(t);
  })();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: search box — recent + popular suggestions on empty focus
 * Predictive search only helps once you type; this fills the empty state.
 * Recents persist in localStorage (recorded when a /search results page loads).
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var KEY = 'zbz-recent-searches';
  function recents() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveRecent(q) {
    q = (q || '').trim().slice(0, 40); if (!q) return;
    try {
      var r = recents().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 5)));
    } catch (e) { /* private mode */ }
  }
  if (location.pathname === '/search') {
    try { var q0 = new URLSearchParams(location.search).get('q'); if (q0) saveRecent(q0); } catch (e) {}
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, ''); }
  function chips(title, items) {
    if (!items.length) return '';
    return '<p>' + title + '</p><div>' + items.map(function (s) {
      return '<a href="/search?q=' + encodeURIComponent(s) + '">' + esc(s) + '</a>';
    }).join('') + '</div>';
  }
  function fill(panel) {
    var pop = ['Z88 pants', 'Hoodies', 'Shorts', 'Leggings', '90s Reissue'];
    try {
      var th = window.zubazGetTeam && window.zubazGetTeam();
      var T = th && window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[th];
      if (T) pop.unshift(T.name);
    } catch (e) {}
    panel.innerHTML = chips('Recent searches', recents()) + chips('Popular', pop.slice(0, 6));
  }
  // Bind every search input — desktop header bar AND the mobile search drawer
  // use separate predictive-search forms.
  function initOne(input) {
    if (input.dataset.zbzSuggest) return; input.dataset.zbzSuggest = '1';
    var wrap = input.closest('form') || input.parentNode;
    if (!wrap) return;
    var panel = document.createElement('div');
    panel.className = 'zbz-srch-suggest'; panel.hidden = true;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    wrap.appendChild(panel);
    function show() { fill(panel); panel.hidden = false; }
    input.addEventListener('focus', function () { if (!input.value) show(); });
    input.addEventListener('input', function () { if (input.value) { panel.hidden = true; } else { show(); } });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) panel.hidden = true; });
  }
  function init() {
    var inputs = document.querySelectorAll('form[action*="/search"] input[name="q"], input[type="search"]');
    if (!inputs.length) return;
    if (!document.getElementById('zbz-srch-suggest-css')) {
      var st = document.createElement('style');
      st.id = 'zbz-srch-suggest-css';
      st.textContent = '.zbz-srch-suggest{position:absolute;top:100%;left:0;min-width:280px;max-width:420px;z-index:60;background:#fff;border:1px solid #e5e5e5;border-radius:10px;box-shadow:0 12px 30px rgba(0,0,0,.14);padding:12px 14px;margin-top:6px;}' +
        '.zbz-srch-suggest p{margin:6px 0;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;opacity:.6;color:#333;}' +
        '.zbz-srch-suggest div{display:flex;flex-wrap:wrap;gap:8px;}' +
        '.zbz-srch-suggest a{display:inline-block;padding:6px 12px;border-radius:999px;background:#f4f4f4;font-size:13px;text-decoration:none;color:#1e1e1e;}' +
        '.zbz-srch-suggest a:hover{background:#ff37b8;color:#fff;}' +
        '@media (max-width:740px){.zbz-srch-suggest{min-width:0;left:0;right:0;max-width:none;}}';
      document.head.appendChild(st);
    }
    Array.prototype.forEach.call(inputs, initOne);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: share-your-cart link
 * Builds a Shopify cart permalink (/cart/variant:qty,...) from the live cart
 * and copies it — fans send a size-picked wishlist to whoever's buying.
 * Button lives on the cart page and in the mini-cart drawer footer.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  function build(cb) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items || !c.items.length) return cb(null);
      var path = c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
      cb(location.origin + '/cart/' + path + '?storefront=true');
    }).catch(function () { cb(null); });
  }
  function addBtn(host) {
    if (!host || host.querySelector('.zbz-share-cart')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'zbz-share-cart';
    b.textContent = '🔗 Share this cart';
    b.style.cssText = 'display:block;margin:10px auto 0;background:none;border:0;font-size:13px;text-decoration:underline;cursor:pointer;opacity:.8;color:inherit;';
    b.addEventListener('click', function () {
      build(function (url) {
        if (!url) { b.textContent = 'Your cart is empty'; setTimeout(function () { b.textContent = '🔗 Share this cart'; }, 3000); return; }
        try { if (typeof window.gtag === 'function') window.gtag('event', 'zbz_share_cart', {}); } catch (e) {}
        var copy = (navigator.clipboard && navigator.clipboard.writeText) ? navigator.clipboard.writeText(url) : Promise.reject();
        copy.then(function () {
          b.textContent = '✓ Link copied — send it to someone!';
          setTimeout(function () { b.textContent = '🔗 Share this cart'; }, 4000);
        }).catch(function () { window.prompt('Copy this cart link:', url); });
      });
    });
    host.appendChild(b);
  }
  function place() {
    if (/^\/cart\/?$/.test(location.pathname)) {
      var host = document.querySelector('#main .cart__recap') || document.querySelector('#main form[action="/cart"]');
      addBtn(host);
    }
    var mc = document.querySelector('#shopify-section-mini-cart .mini-cart__recap');
    if (mc) addBtn(mc);
  }
  function watch() {
    place();
    var host = document.getElementById('shopify-section-mini-cart');
    if (host) new MutationObserver(function () { place(); }).observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: B2B (wholesale) order maximum — "Send this order to Zubaz"
 * Eli 2026-08-18. Wholesale logins (window.zbzB2B) whose cart is over the
 * platform maximum (window.zbzB2BCfg.maxAmount, shop metafield
 * zubaz_b2b.order_max_config — same setting the checkout validation Function
 * reads) get a notice + one button in the cart drawer / cart page. The button
 * POSTs the live cart to /apps/zubaz-b2b/order-request (Shopify App Proxy →
 * cron.zubaz.com), which emails the wholesale team an .xlsx of the order with
 * Reply-To = the customer. Retail shoppers never see any of this.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (!window.zbzB2B) return;
  document.documentElement.classList.add('zbz-b2b'); // wholesale login — CSS hooks (e.g. hide Redo widgets)
  var cfg = window.zbzB2BCfg || {};
  // Per-company override (company metafields zubaz_b2b.order_max / .order_max_message),
  // mirroring what the checkout validation Function enforces: a company max of 0 means
  // NO limit for that company; blank/absent falls back to the store default. Eli 8/19.
  var comp = window.zbzB2BCompany || {};
  var compMax = (comp.max === null || comp.max === undefined || String(comp.max).trim() === '')
    ? null : Number(String(comp.max).replace(/[$,\s]/g, ''));
  if (compMax !== null && !isFinite(compMax)) compMax = null;
  var MAX = compMax !== null ? compMax : (Number(cfg.maxAmount) > 0 ? Number(cfg.maxAmount) : 2500);
  if (compMax !== null ? !(compMax > 0) : cfg.enabled === false) return;
  var MSG = (typeof comp.message === 'string' && comp.message.trim()) ? comp.message
    : ((typeof cfg.message === 'string' && cfg.message.trim()) ? cfg.message : '');
  var lastCart = null, sentKey = null;
  function money(v) { return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function cartKey(c) { return c.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(','); }
  function refetch() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { lastCart = c; place(); }).catch(function () {});
  }
  function over(c) { return c && c.items && c.items.length && (c.total_price / 100) > MAX; }
  function build() {
    var box = document.createElement('div');
    box.className = 'zbz-b2b-max';
    box.style.cssText = 'margin:0 0 12px;padding:12px 14px;border:2px solid #ff37b8;border-radius:6px;background:#fff5fb;font-size:13px;line-height:1.45;color:#111;text-align:left;';
    box.innerHTML =
      '<div class="zbz-b2b-max-headline" style="font-weight:700;margin-bottom:4px;">Your order total exceeds the maximum for orders placed on this platform.</div>' +
      '<div class="zbz-b2b-max-sub" style="margin-bottom:10px;">Send it to our wholesale team with one click and we\'ll place the order for you.</div>' +
      '<button type="button" class="zbz-b2b-send" style="display:inline-block;background:#ff37b8;color:#fff;border:0;border-radius:4px;padding:10px 16px;font-weight:700;font-size:13px;letter-spacing:.02em;cursor:pointer;">Send this order to Zubaz</button>' +
      '<div class="zbz-b2b-max-status" style="margin-top:8px;font-size:12px;color:#444;"></div>';
    var btn = box.querySelector('.zbz-b2b-send'), status = box.querySelector('.zbz-b2b-max-status');
    btn.addEventListener('click', function () {
      if (!lastCart || !lastCart.items || !lastCart.items.length) { status.textContent = 'Your cart is empty.'; return; }
      btn.disabled = true; btn.style.opacity = '.6'; status.textContent = 'Sending\u2026';
      var body = { items: lastCart.items, total_price: lastCart.total_price, note: lastCart.note || '' };
      fetch('/apps/zubaz-b2b/order-request', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok && res.j && res.j.ok) {
            sentKey = cartKey(lastCart);
            btn.textContent = '\u2713 Sent';
            status.textContent = res.j.message || 'Sent \u2014 Gabe will be in touch shortly. A copy was emailed to you as well.';
            try { if (typeof window.gtag === 'function') window.gtag('event', 'zbz_b2b_order_request', { value: lastCart.total_price / 100 }); } catch (e) {}
          } else {
            btn.disabled = false; btn.style.opacity = '1';
            status.textContent = (res.j && res.j.detail) || 'We couldn\'t send that just now \u2014 please email gabej@zubaz.com.';
          }
        })
        .catch(function () { btn.disabled = false; btn.style.opacity = '1'; status.textContent = 'We couldn\'t send that just now \u2014 please email gabej@zubaz.com.'; });
    });
    return box;
  }
  function addTo(host) {
    if (!host) return;
    var existing = host.querySelector('.zbz-b2b-max');
    if (!over(lastCart)) { if (existing) existing.remove(); return; }
    if (existing) {
      if (sentKey && sentKey === cartKey(lastCart)) return;
      // cart changed after a send → re-arm the button
      var b = existing.querySelector('.zbz-b2b-send'); if (b && b.textContent.indexOf('Sent') === 0) { b.textContent = 'Send this order to Zubaz'; b.disabled = false; b.style.opacity = '1'; existing.querySelector('.zbz-b2b-max-status').textContent = ''; }
      return;
    }
    var box = build();
    host.insertBefore(box, host.firstChild);
    var head = box.querySelector('.zbz-b2b-max-headline');
    if (head && MSG) head.textContent = MSG.replace(/\{max\}/g, money(MAX));
    var sub = box.querySelector('.zbz-b2b-max-sub');
    if (sub) sub.textContent = 'Orders over ' + money(MAX) + ' can\'t be checked out here. Send it to our wholesale team with one click and we\'ll place the order for you.';
  }
  function place() {
    if (/^\/cart\/?$/.test(location.pathname)) addTo(document.querySelector('#main .cart__recap') || document.querySelector('#main form[action="/cart"]'));
    addTo(document.querySelector('#shopify-section-mini-cart .mini-cart__recap'));
  }
  function init() {
    refetch();
    ['cart:refresh', 'cart:updated', 'variant:added'].forEach(function (ev) { document.documentElement.addEventListener(ev, function () { setTimeout(refetch, 300); }); });
    var host = document.getElementById('shopify-section-mini-cart');
    if (host) new MutationObserver(function () { place(); }).observe(host, { childList: true, subtree: true });
    setInterval(place, 2500);        // MutationObserver delivery is unreliable on this store
    setInterval(refetch, 15000);     // pick up quantity edits made inside the drawer
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: '90s Mode easter egg
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var KEY = 'zubaz-90s';
  var on = false;

  try { on = localStorage.getItem(KEY) === '1'; } catch (error) { /* private mode */ }

  function apply() {
    document.documentElement.classList.toggle('zubaz-90s', on);
  }

  apply();

  function init() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zubaz-90s-toggle';
    btn.title = "Toggle '90s Mode";
    btn.textContent = "'90s";
    btn.addEventListener('click', function () {
      on = !on;
      apply();
      try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (error) { /* private mode */ }
      if (on && window.zubazConfetti) window.zubazConfetti();
    });
    document.body.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: smarter empty search results
 * Globo renders the /search results asynchronously, so we watch the page:
 * when a query comes back with zero products, show team shortcuts and
 * popular collections instead of a dead end. Hides itself if results appear.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (window.location.pathname.indexOf('/search') !== 0) return;

  var QUICK_LINKS = [
    { label: 'NEW ARRIVALS', href: '/collections/new-arrivals' },
    { label: 'ZUBAZ ORIGINALS', href: '/collections/original-pants' },
    { label: 'ACCESSORIES', href: '/collections/accessories' },
    { label: 'SALE', href: '/collections/sale' }
  ];

  var panel = null;

  function hasQuery() {
    var m = window.location.search.match(/[?&]q=([^&]*)/);
    if (!m) return false;
    try {
      return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().length > 0;
    } catch (error) {
      return m[1].length > 0;
    }
  }

  function resultCount() {
    return document.querySelectorAll(
      '#main .spf-product-card, #main .product-item, #main .product-card'
    ).length;
  }

  function buildPanel() {
    var style = document.createElement('style');
    style.textContent =
      '.zubaz-search-help { max-width: 1000px; margin: 24px auto 60px; padding: 28px 20px 36px; text-align: center; border: 3px solid #ff37b8; border-radius: 12px; background: #fff; }' +
      '.zubaz-search-help[hidden] { display: none; }' +
      '.zubaz-search-help__title { font-weight: 800; text-transform: uppercase; font-size: 18px; margin: 0 0 18px; letter-spacing: .5px; }' +
      '.zubaz-search-help__team-cta { display: inline-block; margin: 0 0 20px; padding: 12px 24px; border-radius: 30px; border: 3px solid transparent; font-weight: 800; text-decoration: none; text-transform: uppercase; }' +
      '.zubaz-search-help__links { display: flex; flex-wrap: wrap; gap: 10px; justify-content: center; margin: 0 0 24px; }' +
      '.zubaz-search-help__links a { padding: 10px 18px; border-radius: 30px; background: #ff37b8; color: #ffffff; font-weight: 700; font-size: 13px; text-decoration: none; }' +
      '.zubaz-search-help__links a:nth-child(even) { background: #f3ff34; color: #282828; }' +
      '.zubaz-search-help__sub { margin: 0 0 14px; color: #555555; }' +
      '.zubaz-search-help__grid { display: grid; grid-template-columns: repeat(8, 1fr); gap: 10px; max-width: 760px; margin: 0 auto; }' +
      '@media (max-width: 740px) { .zubaz-search-help__grid { grid-template-columns: repeat(4, 1fr); } }' +
      '.zubaz-search-help__grid a { display: block; border-radius: 50%; overflow: hidden; border: 2px solid #eeeeee; aspect-ratio: 1; transition: transform .15s ease, border-color .15s ease; }' +
      '.zubaz-search-help__grid a:hover { transform: scale(1.08); border-color: #ff37b8; }' +
      '.zubaz-search-help__grid img { width: 100%; height: 100%; object-fit: cover; display: block; }';
    document.head.appendChild(style);

    panel = document.createElement('div');
    panel.className = 'zubaz-search-help';

    var teamCta = '';
    var myTeam = window.zubazGetTeam && window.zubazGetTeam();
    if (myTeam && window.ZUBAZ_TEAMS[myTeam]) {
      var t = window.ZUBAZ_TEAMS[myTeam];
      teamCta = '<a class="zubaz-search-help__team-cta" href="/collections/' + myTeam + '" style="background:' + t.primary + ';color:' + window.zubazTeamTextColor(t.primary) + ';border-color:' + t.secondary + '">Shop ' + t.name + ' gear →</a><br>';
    }

    var links = QUICK_LINKS.map(function (l) {
      return '<a href="' + l.href + '">' + l.label + '</a>';
    }).join('');

    var badges = Object.keys(window.ZUBAZ_TEAMS).map(function (handle) {
      var team = window.ZUBAZ_TEAMS[handle];
      if (!team.icon) return '';
      return '<a href="/collections/' + handle + '" title="' + team.name + '" aria-label="' + team.name + '"><img loading="lazy" alt="" src="' + team.icon + '&width=200"></a>';
    }).join('');

    panel.innerHTML =
      '<p class="zubaz-search-help__title">No luck with that search — but the zebra’s got you.</p>' +
      teamCta +
      '<div class="zubaz-search-help__links">' + links + '</div>' +
      '<p class="zubaz-search-help__sub">Or jump straight to your team:</p>' +
      '<div class="zubaz-search-help__grid">' + badges + '</div>';

    var host = document.getElementById('main') || document.body;
    host.appendChild(panel);
  }

  function update() {
    if (!hasQuery()) return;

    var empty = resultCount() === 0;
    if (empty && !panel) buildPanel();
    if (panel) panel.hidden = !empty;
  }

  var timer = null;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 400);
  }

  function boot() {
    if (!window.ZUBAZ_TEAMS) { setTimeout(boot, 200); return; }

    setTimeout(update, 1800); // give Globo a chance to render first

    var mainEl = document.getElementById('main');
    if (mainEl) {
      new MutationObserver(schedule).observe(mainEl, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: team banner on search results (Eli pick #2, 2026-07-16)
 * "buffalo bills" is a top search term but over half of those searches end
 * without a click — the mixed results grid buries the curated team page.
 * When the query names an NFL team (full name, unique nickname, or
 * unambiguous city), pin a team-colored banner above the results linking
 * straight to /collections/<team>.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (window.location.pathname.indexOf('/search') !== 0) return;

  function searchQuery() {
    var m = window.location.search.match(/[?&]q=([^&]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return ''; }
  }

  function matchTeam(raw) {
    var q = ' ' + String(raw).toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
    if (q.trim() === '') return null;
    var handles = Object.keys(window.ZUBAZ_TEAMS);
    // Cities shared by two teams (New York, Los Angeles) can't identify one on their own.
    var cityCount = {};
    handles.forEach(function (h) {
      var name = window.ZUBAZ_TEAMS[h].name.toLowerCase();
      var city = name.slice(0, name.lastIndexOf(' '));
      cityCount[city] = (cityCount[city] || 0) + 1;
    });
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i];
      var name = window.ZUBAZ_TEAMS[h].name.toLowerCase();
      var nick = name.slice(name.lastIndexOf(' ') + 1);
      var city = name.slice(0, name.lastIndexOf(' '));
      if (q.indexOf(' ' + name + ' ') !== -1) return h;
      if (q.indexOf(' ' + nick + ' ') !== -1) return h;
      if (cityCount[city] === 1 && q.indexOf(' ' + city + ' ') !== -1) return h;
    }
    return null;
  }

  function insertBanner(h) {
    var t = window.ZUBAZ_TEAMS[h];
    var style = document.createElement('style');
    style.textContent =
      '.zbz-team-search-banner { display: flex; align-items: center; gap: 14px; max-width: 1000px; margin: 18px auto 6px; padding: 10px 18px; border-radius: 12px; border: 3px solid; text-decoration: none; font-weight: 800; text-transform: uppercase; letter-spacing: .5px; }' +
      '.zbz-team-search-banner img { width: 46px; height: 46px; border-radius: 50%; object-fit: cover; flex: none; background: #ffffff; }' +
      '.zbz-team-search-banner small { display: block; font-weight: 700; opacity: .85; letter-spacing: .3px; }' +
      '@media (max-width: 740px) { .zbz-team-search-banner { margin: 12px 12px 4px; padding: 9px 14px; gap: 10px; font-size: 13px; } .zbz-team-search-banner img { width: 38px; height: 38px; } }';
    document.head.appendChild(style);

    var a = document.createElement('a');
    a.className = 'zbz-team-search-banner';
    a.href = '/collections/' + h;
    a.style.background = t.primary;
    a.style.color = window.zubazTeamTextColor(t.primary);
    a.style.borderColor = t.secondary;
    a.innerHTML = (t.icon ? '<img alt="" src="' + t.icon + '&width=100">' : '') +
      '<span>' + (t.slogan ? '<small>' + t.slogan + '</small>' : '') + 'Shop all ' + t.name + ' gear →</span>';
    a.addEventListener('click', function () { window.zbzGa && window.zbzGa('zbz_team_search_banner_click', { team: h }); });

    var host = document.getElementById('main') || document.body;
    host.insertBefore(a, host.firstChild);
    window.zbzGa && window.zbzGa('zbz_team_search_banner_view', { team: h });

    // Globo re-renders the results asynchronously — re-pin the banner if a
    // render pass wipes it out.
    new MutationObserver(function () {
      if (!document.body.contains(a)) {
        var m = document.getElementById('main');
        if (m) m.insertBefore(a, m.firstChild);
      }
    }).observe(host, { childList: true });
  }

  function boot() {
    if (!window.ZUBAZ_TEAMS) { setTimeout(boot, 200); return; }
    var h = matchTeam(searchQuery());
    if (h) insertBanner(h);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Size-on-button: Focal preselects the first size (X-Small), which risks
   accidental wrong-size orders. Rather than fighting the theme's variant
   engine by deselecting (breaks price/availability state), surface the chosen
   size directly in the ADD TO CART label ("ADD TO CART — MEDIUM") so the size
   is impossible to miss at the moment of commitment. Text-only, no form logic
   touched; skips buttons with inner markup or sold-out state. */
(function () {
  // Focal renders the variant picker OUTSIDE the cart form, and the button
  // label lives in a .loader-button__text span (sibling of the spinner).
  function currentSizeLabel() {
    var checked = document.querySelector('.block-swatch-list input:checked, variant-picker input[type=radio]:checked');
    if (!checked) return '';
    var lab = document.querySelector('label[for="' + checked.id + '"]');
    return (lab ? lab.textContent : checked.value || '').trim();
  }
  function decorate() {
    var size = currentSizeLabel();
    if (!size || size.length > 12) return;
    document.querySelectorAll('.product-form__add-button .loader-button__text').forEach(function (span) {
      var txt = (span.textContent || '').trim();
      if (/sold out|unavailable/i.test(txt)) { delete span.dataset.zbzBase; return; }
      if (!span.dataset.zbzBase) span.dataset.zbzBase = txt.split('—')[0].trim() || 'Add to cart';
      span.textContent = span.dataset.zbzBase + ' — ' + size.toUpperCase();
    });
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(decorate, 200); }
  function init() {
    if (!document.querySelector('.product-form__add-button')) return;
    decorate();
    document.addEventListener('change', schedule, true);
    document.addEventListener('variant:changed', schedule);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Codex fix #2 (2026-07-10): size-guard REMOVED same day per Eli — the
   explicit-choice requirement fought the theme/Swatch King/sticky-bar at too
   many points (blocked adds, shaking scroll). The preselected size stays
   clickable and addable everywhere. Kept: the "Size guide" link beside the
   visible size picker. */
(function () {
  'use strict';
  if (!/^\/products\//.test(location.pathname)) return;

  // Swatch King hides the theme's variant markup (visibility:hidden with a
  // real layout box) and renders its own buttons — anchor to the VISIBLE label.
  function visibleSizeEl() {
    var els = document.querySelectorAll('#main label, #main legend, #main span, #main p, #main div');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = (el.textContent || '').trim();
      if (!/^size\b/i.test(t) || t.length > 25) continue;
      if (el.querySelector('.zbz-size-guide-link')) continue;
      if (el.checkVisibility) {
        if (!el.checkVisibility({ checkOpacity: true, visibilityProperty: true })) continue;
      } else {
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) continue;
      }
      return el;
    }
    return null;
  }

  var linkTries = 0;
  function addSizeGuideLink() {
    if (document.querySelector('.zbz-size-guide-link')) return;
    var label = visibleSizeEl();
    if (!label) {
      if (++linkTries < 15) setTimeout(addSizeGuideLink, 500); // SK renders async
      return;
    }
    var a = document.createElement('a');
    a.className = 'zbz-size-guide-link zbz-size-guide-link--inline';
    a.href = '/pages/size-guide';
    a.textContent = 'Size guide 📏';
    a.addEventListener('click', function (e) {
      // Prefer the on-page size chart tab — but only a VISIBLE one. Mobile
      // renders the desktop tab bar hidden alongside its accordion; clicking
      // the hidden twin looks like "nothing happened".
      var tab = [].find.call(
        document.querySelectorAll('#main .product-tabs button, #main .collapsible-toggle, #main summary'),
        function (el) {
          if (!/size\s*(chart|guide)/i.test(el.textContent)) return false;
          return el.checkVisibility
            ? el.checkVisibility({ checkOpacity: true, visibilityProperty: true })
            : el.offsetParent !== null;
        }
      );
      if (tab) {
        e.preventDefault();
        tab.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (tab.getAttribute('aria-expanded') === 'false' || tab.tagName === 'SUMMARY') tab.click();
      }
      // no visible tab → normal navigation to /pages/size-guide
    });
    label.insertAdjacentElement('afterend', a);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addSizeGuideLink);
  else addSizeGuideLink();
})();

/* Codex fix #4 (2026-07-10): long SEO collection descriptions push products
   below the fold on mobile. Clamp to 2 lines with a Read more toggle;
   desktop unchanged and the full text stays in the HTML for SEO. */
(function () {
  'use strict';
  if (!/^\/collections\//.test(location.pathname)) return;
  function init() {
    if (window.innerWidth > 740) return;
    var desc = document.querySelector('.shopify-section--collection-banner .page-header__text-wrapper h1 + div');
    if (!desc || desc.dataset.zbzClamp) return;
    if (desc.getBoundingClientRect().height < 100) return; // already short
    desc.dataset.zbzClamp = '1';
    desc.classList.add('zbz-desc-clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zbz-desc-more';
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('is-expanded');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
    desc.parentNode.insertBefore(btn, desc.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Codex fix #5 (2026-07-10): the feed publishes in bursts, so homepage New
   Arrivals can show 8 near-identical variants of one style (same tee, 8
   schools). Reorder the grid so each style family appears at most twice;
   extras move to the back of the grid, nothing is removed. */
(function () {
  'use strict';
  if (location.pathname !== '/') return;

  function familyKey(title) {
    var t = ' ' + String(title).toLowerCase() + ' ';
    // Feed titles put the team/school after the last comma
    // ("...T-Shirt, TCU" / "...Pants, Arizona Cardinals For Men and Women")
    t = t.replace(/,[^,]*$/, ' ');
    if (window.ZUBAZ_TEAMS) {
      Object.keys(window.ZUBAZ_TEAMS).forEach(function (h) {
        t = t.split(window.ZUBAZ_TEAMS[h].name.toLowerCase()).join(' ');
      });
    }
    // NCAA schools + others the NFL team map does not cover
    ['iowa hawkeyes', 'purdue boilermakers', 'west virginia mountaineers', 'lsu tigers',
     'tcu horned frogs', 'auburn tigers', 'georgia tech yellow jackets', 'syracuse orange',
     'oregon ducks', 'oregon state beavers', 'missouri tigers', 'texas tech red raiders',
     'kansas state wildcats'].forEach(function (n) { t = t.split(n).join(' '); });
    return t.replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function diversePick(products, max) {
    var seen = {}, out = [];
    for (var i = 0; i < products.length && out.length < max; i++) {
      var key = familyKey(products[i].title);
      seen[key] = (seen[key] || 0) + 1;
      if (seen[key] <= 2) out.push(products[i]);
    }
    return out;
  }

  function dedupe() {
    if (window.zubazGetTeam && window.zubazGetTeam()) return; // team mode owns the section
    var heading = [].find.call(document.querySelectorAll('#main .section__header, #main .heading'), function (el) {
      return /new arrivals/i.test(el.textContent);
    });
    if (!heading) return;
    var section = heading.closest('.shopify-section');
    var grid = section && section.querySelector('.product-list');
    if (!grid || grid.dataset.zbzVariety) return;
    grid.dataset.zbzVariety = '1';

    var cards = [].slice.call(grid.querySelectorAll('.product-item'));
    var fams = {};
    cards.forEach(function (card) {
      var titleEl = card.querySelector('.product-item-meta__title');
      fams[familyKey(titleEl ? titleEl.textContent : '')] = true;
    });
    if (Object.keys(fams).length >= 4 || !window.zubazFetchCollection || !window.zbzPersonalizeSection) return;

    // Grid is one burst of near-identical styles — rebuild it with a
    // family-diverse newest-first set (same card system team mode uses).
    window.zubazFetchCollection('zbz-new-in-stock').then(function (products) {
      var valid = (products || []).filter(function (p) {
        if (/gift card/i.test(p.title)) return false;
        if (!p.images || !p.images.length) return false;
        return (p.variants || []).some(function (v) { return v.available !== false; });
      }).sort(function (a, b) { return new Date(b.published_at) - new Date(a.published_at); });
      var picks = diversePick(valid, 8);
      if (picks.length < 4) return;
      window.zbzPersonalizeSection('na', 'New Arrivals', picks, 'New Arrivals',
        'SHOP ALL NEW ARRIVALS', '/collections/new-arrivals');
    }).catch(function () { /* keep server grid */ });
  }

  function boot() { setTimeout(dedupe, 800); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: uniform size labels (Eli 2026-07-16)
 * The catalog carries ~50 spellings of ~9 real sizes — "XX-Large", "2X-Large",
 * "2XL", "2X" and "XXL" are all the same button, and 4XL/5XL arrive as
 * "4x-Large"/"5x-large" (inconsistent case). SellerCloud owns the variant data,
 * so this is DISPLAY ONLY: we rewrite the visible text and never touch option
 * values, inputs or form state. Matching stays on the real value, so add-to-cart
 * and variant selection are unaffected.
 * The N-X pattern is deliberate — a future "6X-Large" normalises itself with no
 * code change. Anything we can't confidently map is LEFT ALONE (youth ranges
 * like "4-5 X-Small", numeric sizes, "Small/Medium" combos map only when every
 * part maps). The daily catalog-tagger reports leftovers so the map can grow.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var EXACT = {
    'x-small': 'XS', 'xsmall': 'XS', 'extra-small': 'XS', 'extra small': 'XS', 'xs': 'XS',
    'small': 'S', 's': 'S',
    'medium': 'M', 'med': 'M', 'm': 'M',
    'large': 'L', 'l': 'L',
    'x-large': 'XL', 'xlarge': 'XL', 'extra-large': 'XL', 'extra large': 'XL', 'xl': 'XL',
    'xx-large': '2XL', 'xxl': '2XL',
    'xxx-large': '3XL', 'xxxl': '3XL'
  };

  function one(t) {
    if (EXACT[t]) return EXACT[t];
    // "2X-Large" / "3XL" / "4x-large" / "5X"  ->  2XL / 3XL / 4XL / 5XL
    var m = t.match(/^([2-9])\s*x[\s-]*(?:l|xl|large)?$/);
    return m ? m[1] + 'XL' : null;
  }

  window.zbzSizeLabel = function (raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return null;
    var t = s.toLowerCase().replace(/\s+/g, ' ');
    var hit = one(t);
    if (hit) return hit === s ? null : hit;
    // Combo sizes ("Small/Medium", "Large/ X-Large") only when BOTH sides map.
    if (t.indexOf('/') > -1) {
      var parts = t.split('/'), out = [];
      for (var i = 0; i < parts.length; i++) {
        var p = one(parts[i].trim());
        if (!p) return null;
        out.push(p);
      }
      var joined = out.join('/');
      return joined === s ? null : joined;
    }
    return null; // youth ranges, numeric sizes, junk -> leave exactly as-is
  };

  /* Rewrite only inside a SIZE option group — never Team, Color or Denomination.
     Swatch King owns this markup and re-renders it, so we re-run on mutation and
     stamp each element so repeat passes are cheap. */
  /* Two different pickers render sizes on this store:
       PDP            -> Swatch King: .swatch-single > legend.swatch-label
       Quick-view drawer -> Focal native: .product-form__option-selector >
                            .product-form__option-info ("Size (Men's): Large")
     Match the label element of either, and never a Team/Color group. */
  function isSizeGroup(root) {
    var lab = root.querySelector('legend, .swatch-label, .block-swatch__legend, .product-form__option-info, label');
    return !!(lab && /size/i.test(lab.textContent || ''));
  }

  /* Swatch King nests the label in an unclassed <span> inside .swatch-button and
     keeps the REAL option value on data-value / orig-value (that's what it
     matches on), so rewriting the visible span is safe for variant selection.
     We read the raw value from the attribute rather than the text, then retarget
     the deepest leaf that renders it. */
  function relabel(btn) {
    if (!btn || btn.dataset.zbzSized === '1') return;
    btn.dataset.zbzSized = '1';
    var raw = btn.getAttribute('data-value') || btn.getAttribute('orig-value') || btn.textContent;
    raw = String(raw == null ? '' : raw).trim();
    var next = window.zbzSizeLabel(raw);
    if (!next) return;
    var target = null;
    if (!btn.children.length) {
      target = btn;
    } else {
      var all = btn.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        if (!all[i].children.length && all[i].textContent.trim() === raw) { target = all[i]; break; }
      }
    }
    if (!target) return;
    // Keep the full wording on hover so nothing is lost, just tidied.
    if (!btn.getAttribute('title')) btn.setAttribute('title', raw);
    target.textContent = next;
  }

  /* <select> pickers: the mobile sticky bar, and the Build-Your-Fit rail whose
     options read "4x-Large — $58.00". Rather than trusting a label (the fit
     builder has none), we detect a size select by CONTENT: if most options
     start with something that maps to a size, it's a size select. That way any
     future dropdown is covered without naming its class here. */
  function splitSize(txt) {
    var t = String(txt == null ? '' : txt).trim();
    var whole = window.zbzSizeLabel(t);
    if (whole) return { next: whole, full: t };
    // "4x-Large — $58.00" / "2XL - $69.99": normalise the part before the dash.
    var m = t.match(/^(.+?)\s+[—–-]\s+(.*)$/);
    if (m) {
      var head = window.zbzSizeLabel(m[1]);
      if (head) return { next: head + ' — ' + m[2], full: t };
    }
    return null;
  }

  function looksLikeSizeSelect(sel) {
    var hits = 0, real = 0;
    for (var i = 0; i < sel.options.length; i++) {
      var t = (sel.options[i].textContent || '').trim();
      if (!t) continue;
      real++;
      var head = t.split(/\s+[—–-]\s+/)[0];
      if (window.zbzSizeLabel(head) || /^(x{0,3}s|s|m|l|x{0,3}l|[2-9]xl)$/i.test(head)) hits++;
    }
    return real >= 2 && hits >= Math.ceil(real / 2);
  }

  function relabelSelect(sel) {
    if (!sel || sel.dataset.zbzSized === '1') return;
    // the fit-builder popup deliberately shows FULL size words (Eli 2026-07-28)
    if (sel.classList.contains('zubaz-fb__variant')) return;
    var lab = (sel.getAttribute('name') || '') + ' ' + (sel.getAttribute('aria-label') || '') +
      ' ' + ((sel.closest('.product-form__option, .swatch-single, fieldset') || {}).textContent || '').slice(0, 40);
    if (!/size/i.test(lab) && !looksLikeSizeSelect(sel)) return;
    sel.dataset.zbzSized = '1';
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i], hit = splitSize(o.textContent);
      // .value is never touched -> the form still submits the real variant.
      if (hit) { if (!o.title) o.title = hit.full; o.textContent = hit.next; }
    }
  }

  /* Rank for ordering. Shopify hands the theme option values in whatever order
     SellerCloud supplied, which is often alphabetical — "2XL, 3XL, Large,
     Medium, Small, X-Large, X-Small". Sort the rendered buttons into real size
     order instead. Anything unrecognised keeps its original position at the end
     rather than being shuffled somewhere misleading. */
  var RANK = { XS: 1, S: 2, M: 3, L: 4, XL: 5, '2XL': 6, '3XL': 7, '4XL': 8, '5XL': 9 };
  function rankOf(btn) {
    var raw = btn.getAttribute('data-value') || btn.getAttribute('orig-value') || btn.textContent;
    var norm = window.zbzSizeLabel(raw) || String(raw || '').trim().toUpperCase();
    return RANK[norm] || 999;
  }

  /* Reorder the button wrappers inside their list. Idempotent by design: a
     second pass finds everything already in place and moves nothing, so the
     MutationObserver that watches for Swatch King re-renders can't loop. */
  function sortGroup(list, itemSel) {
    if (!list) return;
    var items = [].slice.call(list.children).filter(function (el) {
      return el.querySelector ? (el.matches(itemSel) || el.querySelector(itemSel)) : false;
    });
    if (items.length < 2) return;
    var ranked = items.map(function (el, i) {
      var btn = el.matches(itemSel) ? el : el.querySelector(itemSel);
      return { el: el, r: rankOf(btn), i: i };
    });
    var sorted = ranked.slice().sort(function (a, b) { return a.r - b.r || a.i - b.i; });
    var changed = sorted.some(function (o, i) { return o.el !== ranked[i].el; });
    if (!changed) return;                       // already correct -> no DOM churn
    if (sorted.every(function (o) { return o.r === 999; })) return;  // nothing recognised
    var frag = document.createDocumentFragment();
    sorted.forEach(function (o) { frag.appendChild(o.el); });
    list.appendChild(frag);
  }

  function sweep() {
    try {
      var groups = document.querySelectorAll('.swatch-single, variant-picker fieldset, .product-form__option, .product-form__option-selector');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (!isSizeGroup(g)) continue;
        var btns = g.querySelectorAll('.swatch-button, .block-swatch__item');
        for (var j = 0; j < btns.length; j++) relabel(btns[j]);
        // Then put them in real size order (XS -> 5XL), not alphabetical.
        sortGroup(g.querySelector('ul.swatch-view'), '.swatch-button');
        sortGroup(g.querySelector('.block-swatch-list'), '.block-swatch__item');
        // Focal echoes the chosen size next to the label ("Size (Men's): Large").
        var info = g.querySelector('.product-form__option-info');
        if (info) {
          var kids = info.children;
          for (var m = 0; m < kids.length; m++) {
            if (!kids[m].children.length) relabel(kids[m]);
          }
        }
      }
      var sels = document.querySelectorAll('select');
      for (var k = 0; k < sels.length; k++) relabelSelect(sels[k]);
    } catch (e) { /* never let a label tweak break the PDP */ }
  }

  function boot() {
    sweep();
    // Swatch King renders late and the quick-buy drawer injects a whole PDP.
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sweep, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: pattern selector on PDPs (Eli pilot 2026-07-17)
 * Swatch King groups have exactly ONE option dimension (Team), so a second
 * "Pattern" axis can't live in the app. This renders our own Pattern row from
 * assets/zbz-pattern-map.json (families of the SAME garment + gender + team in
 * different patterns — Eli's strict rule). Pilot scope: Z88 Zebra Pant vs Z88
 * Post Pant, all 32 NFL teams. Each pill is a plain link to the sibling PDP,
 * so it's crawlable and can't disturb Swatch King's own selectors.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (!/^\/products\//.test(location.pathname)) return;
  var handle = location.pathname.replace(/^\/products\//, '').split('/')[0].split('?')[0];

  // The GENERATION lives in the filename, not a query param: Shopify's CDN
  // serves mixed stale generations for the same path regardless of ?v= (POPs
  // cached 3 different eras of zbz-pattern-map.json on 07-17), so every map
  // regeneration bumps this suffix and ships a never-before-cached path.
  // Bump it together with the upload — both travel in the same deploy.
  var MAP_FILE = 'zbz-pattern-map-17.json';
  function mapUrl() {
    var tag = document.querySelector('script[src*="custom.js"]');
    if (!tag) return null;
    return tag.src.replace(/custom\.js[^/]*$/, MAP_FILE);
  }

  /* Live swatch auto-cropper: find the busiest (most edges = actual pattern)
     region of THIS product photo that isn't the white leg-gap, a solid panel,
     or a model's skin. Runs client-side per image, results cached in
     sessionStorage so re-renders/navigations are instant. */
  var zbzCropCanvas = null;
  function zbzBestCrop(img, zoom) {
    if (!zbzCropCanvas) { zbzCropCanvas = document.createElement('canvas'); }
    var W = img.naturalWidth, H = img.naturalHeight;
    zbzCropCanvas.width = W; zbzCropCanvas.height = H;
    var cx = zbzCropCanvas.getContext('2d', { willReadFrequently: true });
    cx.drawImage(img, 0, 0);
    var win = 1 / zoom, XS = [25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75], YS = [22, 30, 38, 46, 54, 62, 70], best = null;
    for (var a = 0; a < XS.length; a++) for (var b = 0; b < YS.length; b++) {
      var cxp = XS[a], cyp = YS[b];
      var hw = win * W / 2, hh = win * H / 2;
      var x0 = Math.max(0, Math.round(cxp / 100 * W - hw)), y0 = Math.max(0, Math.round(cyp / 100 * H - hh));
      var w = Math.min(W - x0, Math.round(win * W)), h = Math.min(H - y0, Math.round(win * H));
      if (w < 8 || h < 8) continue;
      var d = cx.getImageData(x0, y0, w, h).data, edge = 0, s = 0, white = 0, black = 0, n = 0;
      for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
        var i = (yy * w + xx) * 4, r = d[i], g = d[i + 1], bl = d[i + 2], l = (r + g + bl) / 3; n++; s += l;
        if (r > 238 && g > 238 && bl > 238) white++; if (l < 22) black++;
        if (xx + 1 < w) { var j = i + 4; edge += Math.abs(r - d[j]) + Math.abs(g - d[j + 1]) + Math.abs(bl - d[j + 2]); }
        if (yy + 1 < h) { var k = i + w * 4; edge += Math.abs(r - d[k]) + Math.abs(g - d[k + 1]) + Math.abs(bl - d[k + 2]); }
      }
      var mean = s / n, wf = white / n, bf = black / n, ed = edge / n;
      var score = Math.min(ed / 120, 1.5) - wf * 1.2 - bf * 0.8 - (mean > 236 ? 0.6 : 0) - (mean < 20 ? 0.6 : 0);
      if (!best || score > best.score) best = { cxp: cxp, cyp: cyp, score: score };
    }
    return best;
  }
  function zbzRefineSwatch(el) {
    try {
      var src = el.getAttribute('data-sw'); if (!src) return;
      var zoom = parseFloat(el.getAttribute('data-z')) || 5;
      var id = 'zbzcrop:' + src.split('?')[0].split('/').pop();
      var cached = null;
      try { cached = sessionStorage.getItem(id); } catch (e) { }
      if (cached) { var p = cached.split(','); el.style.backgroundPosition = p[0] + '% ' + p[1] + '%'; return; }
      var img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = function () {
        var b = zbzBestCrop(img, zoom); if (!b) return;
        el.style.backgroundPosition = b.cxp + '% ' + b.cyp + '%';
        try { sessionStorage.setItem(id, b.cxp + ',' + b.cyp); } catch (e) { }
      };
      img.src = src;
    } catch (e) { /* leave the fallback crop */ }
  }

  function build(fam) {
    if (document.querySelector('.zbz-pattern-row')) return;
    /* Placement must be inside the BUY form, not a "you may also like" card's
       swatch group (crew/hoodie PDPs have several .swatch-single blocks and
       label the team group "Color", not "Team", so the old team-legend hunt
       fell through to groups[0] and could land at the bottom of the page).
       Scope to the add-to-cart form and prefer sitting ABOVE the Size group. */
    var form = (document.querySelector('.product-form__add-button, [name="add"], button[type="submit"][name="add"]') || {}).closest
      ? document.querySelector('.product-form__add-button, [name="add"]').closest('form, .product-form, product-form, .product__info, .product-info, main')
      : null;
    var scope = form || document;
    function legendOf(el) { var l = el.querySelector('legend, .swatch-label, .product-form__option-info, label'); return l ? l.textContent : ''; }
    var singles = scope.querySelectorAll('.swatch-single, .product-form__option');
    var sizeGroup = null, teamGroup = null;
    for (var i = 0; i < singles.length; i++) {
      var t = legendOf(singles[i]);
      if (!sizeGroup && /\bsize\b/i.test(t)) sizeGroup = singles[i];
      if (!teamGroup && /team|color/i.test(t)) teamGroup = singles[i];
    }
    // Preferred: immediately above Size. Fallback: after Team/Color. Last: none.
    var anchor = sizeGroup || teamGroup;
    var placeBefore = !!sizeGroup;
    if (!anchor) return; // buy form not rendered yet — retry via observer

    var row = document.createElement('div');
    row.className = 'zbz-pattern-row';
    // Swatch = each member's OWN product photo (per-team). Product photos mix
    // studio flats and full-body model shots even within one pattern line, so a
    // fixed crop can't work; instead zbzRefineSwatch() analyses EACH image live
    // (edge density = pattern; avoids skin/white gap/solid panels) and sets the
    // crop per pill. The map `c` is only the instant-paint fallback. Text-only
    // groups (tees, ELV) carry no `sw` -> plain name pills.
    var pills = fam.map(function (m) {
      var cur = m.h === handle;
      var src = m.sw || '';
      var c = m.c || [45, 40, 5];
      var sw = src
        ? '<span class="zbz-pattern-swatch" data-sw="' + src + '" data-z="' + c[2] + '" style="background-image:url(' + src + ');background-size:' + (c[2] * 100) + '%;background-position:' + c[0] + '% ' + c[1] + '%"></span>'
        : '';
      return cur
        ? '<span class="zbz-pattern-pill zbz-pattern-pill--current">' + sw + m.p + '</span>'
        : '<a class="zbz-pattern-pill" href="/products/' + m.h + '">' + sw + m.p + '</a>';
    }).join('');
    row.innerHTML = '<span class="zbz-pattern-label">Pattern</span><div class="zbz-pattern-pills">' + pills + '</div>';
    anchor.parentNode.insertBefore(row, placeBefore ? anchor : anchor.nextSibling);
    // Hide a redundant single-option "Color" selector (Eli 2026-07-23): some
    // grouped PDPs — e.g. 90s hoodies — carry a Swatch King "Color" group that
    // holds only THIS product, a dead one-choice picker duplicating Team. When
    // a Pattern row exists and a Color group has <=1 option, hide it.
    try {
      var cGroups = scope.querySelectorAll('.swatch-single');
      for (var ci = 0; ci < cGroups.length; ci++) {
        var clab = cGroups[ci].querySelector('legend, .swatch-label');
        if (!clab || !/\bcolou?r\b/i.test(clab.textContent)) continue;
        var opts = cGroups[ci].querySelectorAll('.swatch-view-item, .swatch-button, .block-swatch__item');
        if (opts.length <= 1) cGroups[ci].style.display = 'none';
      }
    } catch (e) { }
    // Live per-image crop refinement (async; cached per session).
    var swatches = row.querySelectorAll('.zbz-pattern-swatch');
    for (var si = 0; si < swatches.length; si++) zbzRefineSwatch(swatches[si]);
    row.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.zbz-pattern-pill');
      if (a && window.zbzGa) window.zbzGa('zbz_pattern_click', { from: handle, to: (a.getAttribute('href') || '').replace('/products/', '') });
    });
    if (window.zbzGa) window.zbzGa('zbz_pattern_view', { item: handle });
  }

  function boot() {
    var url = mapUrl();
    if (!url) return;
    fetch(url).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (map) {
      var fi = map.h2f && map.h2f[handle];
      if (fi == null) return;
      var fam = map.fams[fi];
      if (!fam || fam.length < 2) return;
      build(fam);
      // Swatch King renders late; keep trying until the row is placed.
      if (!document.querySelector('.zbz-pattern-row')) {
        var tries = 0;
        var t = setInterval(function () {
          build(fam);
          if (document.querySelector('.zbz-pattern-row') || ++tries > 25) clearInterval(t);
        }, 400);
      }
    }).catch(function () { });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: Care Instructions tab (Eli 2026-07-23)
 * Adds a third PDP tab (Description | Size chart | Care Instructions) with the
 * standard Zubaz care label. PURELY ADDITIVE — never touches the description.
 * EXCLUDES accessories (zbz-cat-accessories) and third-party collab lines
 * (FOCO/Forever Collectibles, Northwest, Pets First, For Bare Feet) per Eli.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (location.pathname.indexOf('/products/') !== 0) return;
  var handle = location.pathname.replace(/^\/products\//, '').split('/')[0].split('?')[0];

  var CARE = '<div class="rte"><ul>' +
    '<li>Machine wash cold with like colors</li>' +
    '<li>Turn inside out before washing</li>' +
    '<li>Do not bleach</li>' +
    '<li>Tumble dry low</li>' +
    '<li>Do not iron directly on graphics</li>' +
    '<li>Do not dry clean</li>' +
    '</ul></div>';
  var COLLAB = /forever collectibles|northwest|pets first|for bare feet|foco/i;

  function wireToggle(list) {
    if (list.dataset.zbzTabsOwned) return;
    list.dataset.zbzTabsOwned = '1';
    // Own tab switching for ALL buttons (capture + stop) so Focal's native
    // handler can't fight over the injected panel.
    list.addEventListener('click', function (e) {
      var b = e.target.closest('.tabs-nav__item'); if (!b) return;
      e.stopImmediatePropagation();
      var btns = list.querySelectorAll('.tabs-nav__item');
      for (var i = 0; i < btns.length; i++) {
        var p = document.getElementById(btns[i].getAttribute('aria-controls'));
        btns[i].setAttribute('aria-expanded', 'false'); if (p) p.hidden = true;
      }
      b.setAttribute('aria-expanded', 'true');
      var mp = document.getElementById(b.getAttribute('aria-controls')); if (mp) mp.hidden = false;
    }, true);
  }

  function inject() {
    if (document.getElementById('zbz-care-panel')) return true;
    // Focal renders the PDP info sections as a horizontal tab bar on desktop AND
    // a collapsible accordion on mobile — both live inside one
    // .product-tabs__tab-item-wrapper per section. Deep-clone the Description
    // wrapper so BOTH surfaces work from Focal's own components (a tab-bar-only
    // injection is invisible on mobile, where tabs-nav is display:none).
    var srcWrap = document.querySelector('.product-tabs__tab-item-wrapper');
    var list = document.querySelector('.tabs-nav__item-list');
    if (!srcWrap || !list) return false;
    var CID = 'zbz-care-content';

    var clone = srcWrap.cloneNode(true);
    clone.id = 'zbz-care-panel'; clone.hidden = true;
    // unique ids inside the clone
    var withId = clone.querySelectorAll('[id]');
    for (var i = 0; i < withId.length; i++) {
      withId[i].id = /content$/i.test(withId[i].id) ? CID : ('zbz-care-' + withId[i].id.split('-').pop());
    }
    // mobile accordion header
    var mToggle = clone.querySelector('.collapsible-toggle');
    if (mToggle) {
      var relabelled = false;
      mToggle.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = 'Care Instructions'; relabelled = true; } });
      if (!relabelled) mToggle.insertBefore(document.createTextNode('Care Instructions'), mToggle.firstChild);
      mToggle.setAttribute('aria-controls', CID);
      mToggle.setAttribute('aria-expanded', 'false');
    }
    // body content
    var body = clone.querySelector('collapsible-content, .collapsible') || clone;
    body.id = CID; body.innerHTML = CARE;
    srcWrap.parentElement.appendChild(clone);

    // desktop tab button
    var srcBtn = list.querySelector('.tabs-nav__item');
    var dBtn = srcBtn.cloneNode(true);
    dBtn.setAttribute('aria-controls', 'zbz-care-panel');
    dBtn.setAttribute('aria-expanded', 'false');
    var did = false;
    dBtn.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = 'Care Instructions'; did = true; } });
    if (!did) dBtn.textContent = 'Care Instructions';
    list.appendChild(dBtn);

    wireToggle(list);
    return true;
  }

  function boot(prod) {
    var tags = (prod.tags || []).map(function (t) { return String(t).toLowerCase(); });
    if (tags.indexOf('zbz-cat-accessories') !== -1) return;      // no care tab on accessories
    if (COLLAB.test(prod.vendor || '') || COLLAB.test(prod.title || '')) return; // or collab lines
    if (inject()) return;
    // Focal renders tabs late — retry until present.
    var tries = 0;
    var t = setInterval(function () { if (inject() || ++tries > 25) clearInterval(t); }, 300);
  }

  fetch('/products/' + handle + '.js')
    .then(function (r) { if (!r.ok) throw 0; return r.json(); })
    .then(boot)
    .catch(function () { });
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: PDP description — collapse the intro paragraph (Eli 2026-07-23)
 * Descriptions are one long marketing paragraph followed by the useful spec
 * bullets. Clamp the PARAGRAPH(S) to ~2 lines behind a "Show more" toggle and
 * leave the BULLETS always visible, so the specs a shopper actually wants are
 * the first thing they see. Content is never removed — only visually clamped,
 * so SEO/crawlers still get the full text.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  if (location.pathname.indexOf('/products/') !== 0) return;

  function enhance(rte) {
    if (!rte || rte.dataset.zbzDescDone) return;
    // Only bother when there IS a list — otherwise the paragraph is all there is.
    var list = rte.querySelector(':scope > ul, :scope > ol');
    if (!list) return;
    // Collect the leading paragraphs (everything before the first list).
    var lead = [], n = rte.firstElementChild;
    while (n && n !== list) {
      if (n.tagName === 'P' && n.innerText.trim()) lead.push(n);
      n = n.nextElementSibling;
    }
    if (!lead.length) return;
    rte.dataset.zbzDescDone = '1';

    var box = document.createElement('div');
    box.className = 'zbz-desc-lead zbz-desc-clamped';
    lead[0].parentNode.insertBefore(box, lead[0]);
    lead.forEach(function (p) { box.appendChild(p); });

    // Only add the toggle if the text actually overflows the clamp.
    if (box.scrollHeight - box.clientHeight < 6) { box.classList.remove('zbz-desc-clamped'); return; }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zbz-desc-toggle';
    btn.textContent = 'Show more';
    btn.setAttribute('aria-expanded', 'false');
    box.parentNode.insertBefore(btn, box.nextSibling);
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('zbz-desc-clamped') === false;
      btn.textContent = open ? 'Show less' : 'Show more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function run() {
    // Description panel only — never the size chart / care tabs.
    var wraps = document.querySelectorAll('.product-tabs__tab-item-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      if (wraps[i].id === 'zbz-care-panel') continue;
      var rte = wraps[i].querySelector('.rte');
      if (rte && rte.querySelector(':scope > ul, :scope > ol')) { enhance(rte); break; }
    }
  }

  function boot() {
    run();
    var tries = 0;
    var t = setInterval(function () { run(); if (document.querySelector('.zbz-desc-lead') || ++tries > 25) clearInterval(t); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: unify Quick View across ALL card types (Eli 2026-07-23)
 * The hover-reveal pill originally only covered our two custom grids
 * (zbz-bigfilter + search). The homepage rails (.zubaz-pers-card) and Focal's
 * native cards (.product-item) keep their quick-view button OUTSIDE the image
 * box, so they rendered as an always-on button below/над the photo instead.
 * This moves those controls INTO the image container and tags them with the
 * shared .zbz-qv-media / .zbz-qv-pill classes the CSS styles.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  function doPers(card) {
    if (card.dataset.zbzQv) return;
    var img = card.querySelector('.zubaz-pers-card__img');
    var btn = card.querySelector('.zubaz-pers-card__qv');
    if (!img || !btn) return;
    card.dataset.zbzQv = '1';
    var media = document.createElement('span');
    media.className = 'zbz-qv-media';
    img.parentNode.insertBefore(media, img);
    media.appendChild(img);
    media.appendChild(btn);
    btn.classList.add('zbz-qv-pill');
  }
  function doNative(item) {
    if (item.dataset.zbzQv) return;
    // never inside the cart drawer — its tiny horizontal cards can't carry
    // the pill (Eli 2026-07-29); CSS hides it too but don't even inject
    if (item.closest && item.closest('.mini-cart, .mini-cart__recommendations')) return;
    var wrap = item.querySelector('.product-item__image-wrapper');
    var cta = item.querySelector('.product-item__cta-wrapper');
    var btn = cta && cta.querySelector('.product-item__cta');
    // Only convert genuine Quick view CTAs — leave "Choose options"/"Sold out" alone.
    if (!wrap || !cta || !btn || !/quick view/i.test(btn.textContent)) return;
    item.dataset.zbzQv = '1';
    wrap.classList.add('zbz-qv-media');
    wrap.appendChild(cta);          // the drawer is opened via aria-controls, so moving the button is safe
    btn.classList.add('zbz-qv-pill');
  }
  function run() {
    try {
      var p = document.querySelectorAll('.zubaz-pers-card');
      for (var i = 0; i < p.length; i++) doPers(p[i]);
      var n = document.querySelectorAll('.product-item');
      for (var j = 0; j < n.length; j++) doNative(n[j]);
    } catch (e) { }
  }
  function boot() {
    run();
    // Rails render late and re-render on personalization; keep converting.
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 80); })
      .observe(document.body, { childList: true, subtree: true });
    setInterval(run, 1500); // observer-delivery fallback (see eyebrow IIFE note)
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: Favorites / star-an-item (Eli 2026-07-23)
 * A star in the top-right corner of every product card. Click to save.
 * Storage is the BROWSER (localStorage) — deliberate: the store runs Shopify's
 * new customer accounts (Shopify-hosted, no theme templates), and most shoppers
 * browse logged-out, so a login-gated wishlist would be invisible to them.
 * Saved items are listed at /pages/favorites, reachable from a star + count in
 * the header. Phase 2 (if usage justifies it) syncs the same list to a customer
 * metafield for logged-in shoppers.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var KEY = 'zbz-favs';
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.6l2.9 5.9 6.5.95-4.7 4.6 1.1 6.5L12 17.5 6.2 20.5l1.1-6.5-4.7-4.6 6.5-.95L12 2.6z"/></svg>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) { } paintCount(); }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var a = read(), i = a.indexOf(h);
    if (i === -1) a.push(h); else a.splice(i, 1);
    write(a);
    return i === -1;
  }
  window.zbzFavorites = { list: read, has: has, toggle: toggle };

  function paintCount() {
    var n = read().length;
    var els = document.querySelectorAll('.zbz-fav-count');
    for (var i = 0; i < els.length; i++) { els[i].textContent = n; els[i].hidden = (n === 0); }
  }

  function addHeader() {
    // The theme renders TWO .header__icon-list blocks: one in
    // .header__inline-navigation (mobile-only, .hidden-desk) and one in
    // .header__secondary-links. The secondary-links list is visible at BOTH
    // breakpoints (it holds the cart), so the star goes there ONLY — adding it
    // to both put two stars in the mobile header (Eli caught it on his phone).
    // Star goes in BOTH lists — the left (inline-nav) copy shows on MOBILE
    // (Eli 2026-07-28: star on the other side of the tag, next to search),
    // the secondary-links copy shows on DESKTOP. CSS hides the off-breakpoint
    // one (.zbz-fav-link--left / --right).
    var lists = document.querySelectorAll('.header__icon-list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.querySelector('.zbz-fav-link')) continue;
      var left = !!list.closest('.header__inline-navigation');
      var a = document.createElement('a');
      a.href = '/pages/favorites';
      a.className = 'header__icon-wrapper tap-area zbz-fav-link ' + (left ? 'zbz-fav-link--left' : 'zbz-fav-link--right');
      a.setAttribute('aria-label', 'My favorites');
      a.innerHTML = STAR + '<span class="zbz-fav-count" hidden>0</span>';
      if (left) list.appendChild(a); // after the search icon
      else list.insertBefore(a, list.querySelector('a[href*="/cart"]') || null);
    }
    paintCount();
  }

  function handleOf(el) {
    var a = el.querySelector('a[href*="/products/"]');
    if (!a && el.closest) a = el.closest('a[href*="/products/"]');
    if (!a) {
      var card = el.closest && el.closest('.product-item, .zubaz-pers-card, .zbz-bf-card, .zbz-srch-card');
      if (card) a = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
    }
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function addStar(box) {
    if (!box || box.dataset.zbzFav) return;
    // no stars on the cart drawer's tiny rail cards (Eli 2026-07-29)
    if (box.closest && box.closest('.mini-cart, .mini-cart__recommendations')) return;
    var handle = handleOf(box);
    if (!handle) return;
    box.dataset.zbzFav = '1';
    var on = has(handle);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'zbz-fav-star' + (on ? ' is-on' : '');
    b.setAttribute('aria-label', 'Save to favorites');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('data-handle', handle);
    b.innerHTML = STAR;
    box.appendChild(b);
  }

  function scan() {
    try {
      var sel = '.zbz-bf-media, .zbz-srch-media, .zbz-qv-media, .product-item__image-wrapper, .zubaz-pers-card';
      var boxes = document.querySelectorAll(sel);
      for (var i = 0; i < boxes.length; i++) {
        var b = boxes[i];
        if (b.classList.contains('zubaz-pers-card') && b.querySelector('.zbz-qv-media')) continue;
        addStar(b);
      }
    } catch (e) { }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.zbz-fav-star');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-handle');
    var on = toggle(h);
    var same = document.querySelectorAll('.zbz-fav-star[data-handle="' + h + '"]');
    for (var i = 0; i < same.length; i++) {
      same[i].classList.toggle('is-on', on);
      same[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    if (window.zbzGa) window.zbzGa(on ? 'zbz_favorite_add' : 'zbz_favorite_remove', { item: h });
    if (on) { b.classList.add('zbz-fav-pop'); setTimeout(function () { b.classList.remove('zbz-fav-pop'); }, 320); }
    var card = b.closest('.zbz-fav-card');
    if (card && !on) { card.remove(); renderIfEmpty(); }
  }, true);

  function addPdpStar() {
    if (location.pathname.indexOf('/products/') !== 0) return;
    if (document.querySelector('.zbz-fav-pdp')) return;
    var h1 = document.querySelector('.product-meta__title') || document.querySelector('.product-info h1, .product__info h1, h1');
    if (!h1) return;
    // Wait for the eyebrow/title rewriter to finish with the h1 first — it
    // only rewrites plain-text titles, so inserting our button early would
    // block the display-title cleanup. run() polls, so this retries.
    if (!h1.dataset.zbzEyed) return;
    var handle = location.pathname.replace(/^\/products\//, '').split('/')[0].split('?')[0];
    var on = has(handle);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'zbz-fav-star zbz-fav-pdp' + (on ? ' is-on' : '');
    b.setAttribute('data-handle', handle);
    b.setAttribute('aria-label', 'Add to favorites');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.innerHTML = STAR + '<span>Favorite</span>';
    // inline, right of the title's last word (Eli 2026-07-28)
    h1.appendChild(document.createTextNode(' '));
    h1.appendChild(b);
  }

  function money(c) { try { return '$' + (c / 100).toFixed(2); } catch (e) { return ''; } }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }

  function renderIfEmpty() {
    var root = document.getElementById('zbz-favorites-root');
    if (root && !read().length) renderPage();
  }

  function renderPage() {
    var root = document.getElementById('zbz-favorites-root');
    if (!root) return;
    var favs = read();
    if (!favs.length) {
      root.innerHTML = '<div class="zbz-fav-empty"><p><strong>No favorites yet.</strong></p>' +
        '<p>Tap the star on any product to save it here.</p>' +
        '<p><a class="button button--primary" href="/collections/new-arrivals">Shop New Arrivals</a></p></div>';
      return;
    }
    // The default page template caps content at ~670px, which squeezes a
    // 4-up product grid; widen just this page.
    var host = root.closest && root.closest('.page-content');
    if (host) host.classList.add('zbz-fav-page');
    root.innerHTML = '<div class="zbz-fav-grid"></div>';
    var grid = root.firstChild;
    favs.forEach(function (h) {
      fetch('/products/' + h + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          // featured_image already carries ?v=... — appending '?width' makes a
          // malformed double-query and Shopify serves the FULL-size original.
          var fi = p.featured_image || '';
          var img = fi ? (fi + (fi.indexOf('?') > -1 ? '&' : '?') + 'width=400') : '';
          var d = document.createElement('div');
          d.className = 'zbz-fav-card';
          d.innerHTML =
            '<div class="zbz-qv-media">' +
              '<a href="/products/' + p.handle + '">' + (img ? '<img loading="lazy" alt="" src="' + img + '">' : '') + '</a>' +
              '<button type="button" class="zbz-fav-star is-on" data-handle="' + p.handle + '" aria-label="Remove from favorites">' + STAR + '</button>' +
            '</div>' +
            '<a class="zbz-fav-title" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
            '<div class="zbz-fav-price">' + money(p.price) + '</div>';
          grid.appendChild(d);
        })
        .catch(function () { });
    });
  }

  function run() { addHeader(); scan(); addPdpStar(); paintCount(); }

  function boot() {
    run();
    renderPage();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 90); })
      .observe(document.body, { childList: true, subtree: true });
    setInterval(run, 1500); // observer-delivery fallback (see eyebrow IIFE note)
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();


/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: league | team eyebrow + display-title cleanup (Eli 2026-07-28)
 * Pink "NFL | BUFFALO BILLS" eyebrow above every product name, and the
 * redundant league token + team name are stripped from the DISPLAYED title
 * only. Data is untouched (same technique as the size-label normalizer):
 * product titles in Shopify/SellerCloud, document.title, and the JSON-LD
 * schema all keep the full name — this is a render-layer rewrite.
 * Covers all card systems (bigfilter, search, homepage rails, Focal native,
 * favorites) and the PDP h1.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var NFL = ['Arizona Cardinals', 'Atlanta Falcons', 'Baltimore Ravens', 'Buffalo Bills', 'Carolina Panthers', 'Chicago Bears', 'Cincinnati Bengals', 'Cleveland Browns', 'Dallas Cowboys', 'Denver Broncos', 'Detroit Lions', 'Green Bay Packers', 'Houston Texans', 'Indianapolis Colts', 'Jacksonville Jaguars', 'Kansas City Chiefs', 'Las Vegas Raiders', 'Los Angeles Chargers', 'Los Angeles Rams', 'Miami Dolphins', 'Minnesota Vikings', 'New England Patriots', 'New Orleans Saints', 'New York Giants', 'New York Jets', 'Philadelphia Eagles', 'Pittsburgh Steelers', 'San Francisco 49ers', 'Seattle Seahawks', 'Tampa Bay Buccaneers', 'Tennessee Titans', 'Washington Commanders',
    /* legacy names still present in older titles */
    'Oakland Raiders', 'Washington Football Team', 'Washington Redskins', 'St. Louis Rams', 'San Diego Chargers'];
  var NCAA = ['LSU Tigers', 'Auburn Tigers', 'Georgia Tech Yellow Jackets', 'Kansas Jayhawks', 'Oregon State Beavers', 'Purdue Boilermakers', 'Syracuse Orange', 'TCU Horned Frogs', 'West Virginia Mountaineers', 'Iowa Hawkeyes', 'Michigan State Spartans', 'Duke Blue Devils', 'Missouri Tigers', 'Wisconsin Badgers', 'Nebraska Cornhuskers', 'Ohio State Buckeyes', 'Oklahoma Sooners', 'Florida State Seminoles', 'Florida Gators', 'Alabama Crimson Tide', 'Tennessee Volunteers', 'Kentucky Wildcats', 'Michigan Wolverines', 'Penn State Nittany Lions', 'Georgia Bulldogs', 'Clemson Tigers', 'Texas Longhorns', 'Arizona State Sun Devils', 'Oregon Ducks'];
  var NLL = ['Albany FireWolves', 'Buffalo Bandits', 'Calgary Roughnecks', 'Colorado Mammoth', 'Georgia Swarm', 'Halifax Thunderbirds', 'Las Vegas Desert Dogs', 'Ottawa Black Bears', 'Philadelphia Wings', 'Rochester Knighthawks', 'San Diego Seals', 'Saskatchewan Rush', 'Toronto Rock', 'Vancouver Warriors'];

  var TEAMS = [];
  NFL.forEach(function (n) { TEAMS.push({ n: n, l: 'NFL' }); });
  NCAA.forEach(function (n) { TEAMS.push({ n: n, l: 'NCAA' }); });
  NLL.forEach(function (n) { TEAMS.push({ n: n, l: 'NLL' }); });
  // longest first so "Washington Football Team" wins over any shorter overlap
  TEAMS.sort(function (a, b) { return b.n.length - a.n.length; });

  var LEAGUES = ['NCAA', 'NFL', 'NLL', 'MLB', 'NBA', 'NHL'];

  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function derive(title) {
    var league = null, team = null, i;
    for (i = 0; i < LEAGUES.length; i++) {
      if (new RegExp('\\b' + LEAGUES[i] + '\\b', 'i').test(title)) { league = LEAGUES[i]; break; }
    }
    var low = title.toLowerCase();
    for (i = 0; i < TEAMS.length; i++) {
      if (low.indexOf(TEAMS[i].n.toLowerCase()) !== -1) { team = TEAMS[i]; break; }
    }
    if (!league && team) league = team.l;
    if (!league && !team) return null;
    var cleaned = title;
    if (league) cleaned = cleaned.replace(new RegExp('\\s*\\b' + league + '\\b', 'i'), ' ');
    if (team) cleaned = cleaned.replace(new RegExp('\\s*,?\\s*' + escRe(team.n), 'i'), ' ');
    cleaned = cleaned
      .replace(/\s{2,}/g, ' ')
      .replace(/\s+,/g, ',')
      .replace(/,\s*(,|$)/g, '$1')
      .replace(/^\s*[-,–]\s*/, '')
      .replace(/[-,–]\s*$/, '')
      .trim();
    var eyebrow = league || '';
    if (team) eyebrow += (eyebrow ? ' | ' : '') + team.n.toUpperCase();
    return { e: eyebrow, c: cleaned || title };
  }
  window.zbzTitleParts = derive;

  var SEL = '.zbz-bf-card-title, .zbz-srch-card-title, .zubaz-pers-card__name, .product-item-meta__title, .zbz-fav-title, .product-meta__title';

  function apply(el) {
    if (el.dataset.zbzEyed) return;
    // only rewrite plain-text titles; anything with child elements is left alone
    if (el.children.length) { el.dataset.zbzEyed = 'skip'; return; }
    var full = (el.textContent || '').trim();
    if (!full) return;
    el.dataset.zbzEyed = '1';
    var d = derive(full);
    if (!d) return;
    el.dataset.zbzFull = full;
    el.textContent = d.c;
    if (!el.getAttribute('title')) el.setAttribute('title', full);
    var span = document.createElement('span');
    span.className = 'zbz-eyebrow' + (el.classList.contains('product-meta__title') ? ' zbz-eyebrow--pdp' : '');
    span.textContent = d.e;
    // the cart renders duplicate titles per breakpoint (hidden-phone /
    // hidden-tablet-and-up) — the eyebrow must hide with its own title or
    // both copies show at once (Eli 2026-07-28)
    var vis = ['hidden-phone', 'hidden-tablet-and-up', 'hidden-tablet', 'hidden-lap-and-up', 'hidden-pocket', 'hidden-desk'];
    for (var vi = 0; vi < vis.length; vi++) if (el.classList.contains(vis[vi])) span.classList.add(vis[vi]);
    el.parentNode.insertBefore(span, el);
  }

  function scan() {
    try {
      var els = document.querySelectorAll(SEL);
      for (var i = 0; i < els.length; i++) apply(els[i]);
    } catch (e) { }
  }

  function boot() {
    scan();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); })
      .observe(document.body, { childList: true, subtree: true });
    // Belt-and-braces: a third-party script on the page interferes with
    // MutationObserver delivery (observed 2026-07-28: post-load renders like
    // the NA rail never got rescanned). scan() is cheap and idempotent
    // (dataset-guarded), so poll as a fallback.
    setInterval(scan, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();


/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: team-page fit-builder tile + popup (Eli 2026-07-28)
 * On team collection pages the inline "Build Your <Team> Fit" section is
 * hidden and replaced by a team-colored promo tile under the filters
 * ("BUILD THE ULTIMATE <TEAM> OUTFIT — LET'S GO"). Clicking it opens the
 * SAME fit-builder section in a popup overlay (the DOM node is moved, so
 * all builder logic keeps working untouched). Also relocates the category
 * circles to sit right above the product grid. Mobile (filters live in a
 * drawer): the tile renders above the grid instead so it stays reachable.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var m = location.pathname.match(/^\/collections\/([^/?#]+)/);
  if (!m) return;
  var handle = m[1];

  function nicknameLines(name) {
    return name.toUpperCase().split(' ').join('<br>');
  }

  // NCAA schools + NLL aren't in ZUBAZ_TEAMS (that map is the NFL picker) but
  // their team pages get the same treatment (Eli 2026-07-28)
  var EXTRA_TEAMS = {
    'lsu-tigers': { name: 'LSU Tigers', primary: '#461D7C', secondary: '#FDD023' },
    'auburn-tigers': { name: 'Auburn Tigers', primary: '#0C2340', secondary: '#E87722' },
    'georgia-tech-yellow-jackets': { name: 'Georgia Tech', primary: '#B3A369', secondary: '#003057' },
    'kansas-jayhawks': { name: 'Kansas Jayhawks', primary: '#0051BA', secondary: '#E8000D' },
    'oregon-state-beavers': { name: 'Oregon State Beavers', primary: '#DC4405', secondary: '#000000' },
    'purdue-boilermakers': { name: 'Purdue Boilermakers', primary: '#CEB888', secondary: '#000000' },
    'syracuse-orange': { name: 'Syracuse Orange', primary: '#F76900', secondary: '#002D62' },
    'tcu-horned-frogs': { name: 'TCU Horned Frogs', primary: '#4D1979', secondary: '#A3A9AC' },
    'west-virginia-mountaineers': { name: 'West Virginia Mountaineers', primary: '#002855', secondary: '#EAAA00' },
    'iowa-hawkeyes': { name: 'Iowa Hawkeyes', primary: '#FFCD00', secondary: '#000000' },
    'duke-blue-devils': { name: 'Duke Blue Devils', primary: '#003087', secondary: '#FFFFFF' },
    'missouri-tigers': { name: 'Missouri Tigers', primary: '#F1B82D', secondary: '#000000' },
    'oregon-ducks': { name: 'Oregon Ducks', primary: '#154733', secondary: '#FEE123' },
    'buffalo-bandits': { name: 'Buffalo Bandits', primary: '#F26522', secondary: '#000000' }
  };

  function fgFor(bg) {
    return window.zubazTeamTextColor ? window.zubazTeamTextColor(bg) : '#ffffff';
  }

  function boot() {
    var team = (window.ZUBAZ_TEAMS && window.ZUBAZ_TEAMS[handle]) || EXTRA_TEAMS[handle];
    if (window.ZUBAZ_TEAMS && !team) return true; // not a team page — stop polling
    if (!team) return false; // ZUBAZ_TEAMS not loaded yet — keep polling
    var main = document.querySelector('.zbz-bf-main');
    var aside = document.querySelector('.zbz-bf-aside');

    // category circles sit directly above the filters + products row
    var bf = document.querySelector('.zbz-bf');
    var cats = document.querySelector('.zbz-bf-teamcats');
    if (cats && bf && cats.nextElementSibling !== bf) bf.parentNode.insertBefore(cats, bf);

    var fit = document.querySelector('.shopify-section--zubaz-fit-builder');
    if (!fit || !main || document.querySelector('.zbz-fitcta')) return false;

    fit.style.display = 'none';

    var ov = document.createElement('div');
    ov.className = 'zbz-fit-overlay';
    ov.innerHTML = '<div class="zbz-fit-overlay__panel"><button type="button" class="zbz-fit-overlay__close" aria-label="Close">×</button><div class="zbz-fit-overlay__body"></div></div>';
    document.body.appendChild(ov);

    // team-color the popup panel too (Eli 2026-07-28)
    var panel = ov.querySelector('.zbz-fit-overlay__panel');
    panel.style.background = team.primary || '#06356e';
    ov.classList.add('zbz-fit-overlay--team');
    ov.style.setProperty('--zbz-fit-fg', fgFor(team.primary || '#06356e'));

    var tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'zbz-fitcta';
    tile.style.background = team.primary || '#06356e';
    tile.style.color = fgFor(team.primary || '#06356e');
    var accent = team.secondary || '#ff37b8';
    tile.innerHTML =
      '<span class="zbz-fitcta__eyebrow" style="color:' + accent + '">BUILD THE</span>' +
      '<span class="zbz-fitcta__title">ULTIMATE<br>' + nicknameLines(team.name) + '<br>OUTFIT</span>' +
      '<span class="zbz-fitcta__go" style="color:' + accent + '">LET&#39;S GO &rsaquo;&rsaquo;&rsaquo;</span>';

    var mobile = window.matchMedia('(max-width: 999px)').matches;
    if (!mobile && aside) aside.appendChild(tile);
    else main.insertBefore(tile, main.firstChild); // cats live OUTSIDE main now

    function openOv() {
      ov.querySelector('.zbz-fit-overlay__body').appendChild(fit);
      fit.style.display = '';
      ov.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (window.zbzGa) window.zbzGa('zbz_fit_popup_open', { team: handle });
    }
    function closeOv() {
      ov.classList.remove('is-open');
      fit.style.display = 'none';
      document.documentElement.style.overflow = '';
    }
    tile.addEventListener('click', openOv);
    ov.addEventListener('click', function (e) {
      if (e.target === ov || (e.target.closest && e.target.closest('.zbz-fit-overlay__close'))) closeOv();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOv(); });
    return true;
  }

  // the filter widget renders late; poll until placed (observer delivery is
  // unreliable on this site — see eyebrow IIFE note)
  var tries = 0;
  var iv = setInterval(function () {
    if (boot() || ++tries > 60) clearInterval(iv);
  }, 500);
})();



/* ------------------------------------------------------------------------------------------------------------
 * ZUBAZ CUSTOM: mobile drawer league panels -> flat team list with logos (Eli 2026-07-28)
 * Opening NFL / NCAA / NLL in the mobile menu should show ONLY the full team
 * list (official logos) with the Shop All link at the bottom - no alpha
 * groups, no Type/Category/Accessories submenus, no promo image cards.
 * Desktop mega menu is untouched (separate markup). Team links are harvested
 * from the panel's own nested submenus (filtered against the known 46 team
 * handles), so menu edits keep working without touching this code.
 * ------------------------------------------------------------------------------------------------------------ */
(function () {
  var LEAGUES = ['NFL', 'NCAA', 'NLL'];
  var EXTRA = ['auburn-tigers', 'duke-blue-devils', 'georgia-tech-yellow-jackets', 'iowa-hawkeyes', 'kansas-jayhawks', 'lsu-tigers', 'missouri-tigers', 'oregon-ducks', 'oregon-state-beavers', 'purdue-boilermakers', 'syracuse-orange', 'tcu-horned-frogs', 'west-virginia-mountaineers', 'buffalo-bandits'];

  function teamHandles() {
    var set = {}, k, i;
    if (window.ZUBAZ_TEAMS) for (k in window.ZUBAZ_TEAMS) set[k] = 1;
    for (i = 0; i < EXTRA.length; i++) set[EXTRA[i]] = 1;
    return set;
  }

  function logoUrl(handle) {
    var base = window.zbzLogoBase || '';
    return base ? base.replace('zbz-logo-chicago-bears.png', 'zbz-logo-' + handle + '.png') : '';
  }

  // league logo (or the silver Zubaz tag / an emoji) in front of the
  // level-1 row labels (Eli 2026-07-29)
  function decorateLevel1(btn, label) {
    if (btn.dataset.zbzLgLogo) return;
    var lc = label.toLowerCase();
    var src = '', emoji = '';
    if (LEAGUES.indexOf(label) !== -1) {
      src = logoUrl('x').replace('zbz-logo-x.png', 'zbz-league-logo-' + lc + '.png');
    } else if (label === 'Zubaz Original') {
      var tag = document.querySelector('.header__logo-image');
      if (tag) src = tag.currentSrc || tag.src;
    } else if (lc === 'new') {
      emoji = '🔥'; // fire
    } else if (lc === 'sale') {
      emoji = '💰'; // money bag
    } else if (lc.indexOf('gift') === 0) {
      emoji = '🎁'; // gift
    } else if (lc === 'accessories') {
      emoji = '🐕'; // Eli's pick — accessories = dog toys, blankets/towels, socks
    }
    if (!src && !emoji) return;
    btn.dataset.zbzLgLogo = '1';
    btn.classList.add('zbz-mnav-lg1');
    var lead;
    if (src) {
      lead = document.createElement('img');
      lead.className = 'zbz-mnav-league-logo';
      lead.alt = '';
      lead.loading = 'lazy';
      lead.onerror = function () { this.style.display = 'none'; };
      lead.src = src;
    } else {
      lead = document.createElement('span');
      lead.className = 'zbz-mnav-league-logo zbz-mnav-emoji';
      lead.textContent = emoji;
    }
    btn.insertBefore(lead, btn.firstChild);
  }

  function transform() {
    var drawer = document.getElementById('mobile-menu-drawer');
    if (!drawer) return;
    var set = teamHandles();
    var links1 = drawer.querySelectorAll('li.mobile-nav__item[data-level="1"] > a.mobile-nav__link');
    for (var l1 = 0; l1 < links1.length; l1++) decorateLevel1(links1[l1], (links1[l1].textContent || '').trim());
    var toggles = drawer.querySelectorAll('li.mobile-nav__item[data-level="1"] > button.mobile-nav__link');
    for (var t = 0; t < toggles.length; t++) {
      var btn = toggles[t];
      decorateLevel1(btn, (btn.textContent || '').trim());
      if (LEAGUES.indexOf((btn.textContent || '').trim()) === -1) continue;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel || panel.dataset.zbzTeamified) continue;
      var list = panel.querySelector('ul.mobile-nav');
      if (!list) continue;

      var anchors = panel.querySelectorAll('a.mobile-nav__link[href*="/collections/"]');
      var seen = {}, teams = [], a, m, href;
      for (a = 0; a < anchors.length; a++) {
        href = anchors[a].getAttribute('href') || '';
        m = href.match(/\/collections\/([a-z0-9-]+)/);
        if (!m || !set[m[1]] || seen[m[1]]) continue;
        seen[m[1]] = 1;
        teams.push({ handle: m[1], name: (anchors[a].textContent || '').trim(), href: href });
      }
      if (!teams.length) continue;
      panel.dataset.zbzTeamified = '1';

      // hide everything except the Shop All link; kill the promo image cards
      var kids = list.children, shopAll = null, c, li, link;
      for (c = 0; c < kids.length; c++) {
        li = kids[c];
        link = li.querySelector(':scope > a');
        if (link && /^shop all/i.test((link.textContent || '').trim())) { shopAll = li; continue; }
        li.classList.add('zbz-mnav-hidden');
      }
      var imgs = panel.querySelectorAll('.mobile-nav__images-wrapper');
      for (c = 0; c < imgs.length; c++) imgs[c].classList.add('zbz-mnav-hidden');

      for (c = 0; c < teams.length; c++) {
        var li2 = document.createElement('li');
        li2.className = 'mobile-nav__item zbz-mnav-team-item';
        li2.setAttribute('data-level', '2');
        var a2 = document.createElement('a');
        a2.className = 'mobile-nav__link zbz-mnav-team';
        a2.href = teams[c].href;
        var img = document.createElement('img');
        img.className = 'zbz-mnav-logo';
        img.alt = '';
        img.loading = 'lazy';
        img.onerror = function () { this.style.visibility = 'hidden'; };
        img.src = logoUrl(teams[c].handle);
        a2.appendChild(img);
        a2.appendChild(document.createTextNode(teams[c].name));
        li2.appendChild(a2);
        if (shopAll) list.insertBefore(li2, shopAll); else list.appendChild(li2);
      }
    }
  }

  function boot() {
    transform();
    // idempotent (dataset-guarded); poll in case the drawer re-renders
    setInterval(transform, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
